import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import './AppointmentModule.css';
import {
    Box, Typography, Button, TextField, Chip, CircularProgress, IconButton, Tooltip, Avatar,
    Dialog, DialogTitle, DialogContent, DialogActions, FormControl, InputLabel, Select, MenuItem,
    FormControlLabel, Checkbox, Popper, Paper, Stack, OutlinedInput, Skeleton, Divider, Badge, Drawer
} from '@mui/material';
import { X, Search, MoreVertical, Eye, Pencil, CheckCircle, Trash2, MessageSquare, Phone, Calendar, Grid, List, Settings, FileText, CheckCircle2, Paperclip, Send, User as UserIcon, Filter } from 'lucide-react';
import LaunchIcon from '@mui/icons-material/Launch';
import { PiExport } from 'react-icons/pi';
import { Icon } from '@iconify/react';
import { parseCustomDate } from '../../../utils/dateUtils';
import PremiumModuleCards from '../../Task/Components/common/PremiumModuleCards';
import PremiumModuleTable from '../../Task/Components/common/PremiumModuleTable';
import { getStatusDescriptor, formatDate } from '../../Task/Components/common/premiumUtils';
import DynamicCalendar from '../../../components/DynamicCalendar/DynamicCalendar';
import AppointmentFilterationActions from './AppointmentFilterationActions';
import SubHeader from '../../../components/common/SubHeader/SubHeader';
import AppointmentDetails from './AppointmentDetails';
import Panels, { AppointmentTaskDetailPanel } from '../../../components/common/Panels/Panels';
import EntityEdit from '../../../components/common/EntityEdit/EntityEdit';
import LeadActionOperation from '../../../common/LeadActionOperation/LeadActionOperation';

import usePermissions from '../../Master_Settings/usePermissions';
import useFieldMasking from '../../Master_Settings/useFieldMasking';
import API_ENDPOINTS from '../../../config/apiEndpoints';
import OptionMenu from '../../../components/common/Template_Layouts/@core/components/option-menu';
import CustomAvatar from '../../../components/common/Template_Layouts/@core/components/mui/Avatar';
import { getInitials, getAvatarColorScheme, isGenericAvatar } from '../../../utils/helpers';
import { MassOperationPanel, MassOperationDrawer, MassEntityActionMenu } from '../../../components/common/MassOperation/MassOperation';
import GridMainPanelLayout from '../../../components/common/Panels/GridMainPanelLayout';
import { motion, AnimatePresence } from 'framer-motion';
import { LeadDetails as CommonLeadDetails } from '../../../components/common/LeadDetails/LeadDetails';
import UniversalDetailContent from '../../../components/common/Panels/UniversalDetailContent';
import PopUpModal from '../../../components/PopUpModal/PopUpModal';
import AddAppointment from '../../Task/Forms/AddAppointment';
import { Plus } from 'lucide-react';
import ScoreCard from '../../../components/common/ScoreCard/ScoreCard';
import Loader from '../../../components/Loader/Loader';

// API Configuration
const API_BASE = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
const WCF_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
const GET_APPOINTMENTS_API = `${API_BASE}/UserCRM/GetTaskListByUserIdNew`;
const NEWV3_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
const GetAppointment_Details = `${NEWV3_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_TASK_DETAILS_BYID}`;
//const Mark_As_complete = `${API_BASE}${API_ENDPOINTS.APPOINTMENTS.MARK_AS_COMPLETE}`;
const For_Owner = `${API_BASE}${API_ENDPOINTS.APPOINTMENTS.GET_USER_HIRERARCHY_LIST}`;
const Collabrator = `${API_BASE}${API_ENDPOINTS.APPOINTMENTS.GET_USERLIST_PHYSICALAPP_VIEW}`;
const ADD_TASK_APPOINTMENT = `${API_BASE}${API_ENDPOINTS.TASKS.INSERT_NEW_TASK_OR_APPOINTMENT}`;
//const Mass_Update = `${WCF_BASE}${API_ENDPOINTS.APPOINTMENTS.MASS_UPDATE}`;
const GET_GRID_COMMENTS = `${WCF_BASE}${API_ENDPOINTS.APPOINTMENTS.GET_TASK_COMMENTS}`;
const ADD_COMMENT_HANDLER = `${WCF_BASE}${API_ENDPOINTS.APPOINTMENTS.ATTCHMENT_HANDLER_ADD_COMMENT}`;
const Sales_Activity = `${API_BASE}${API_ENDPOINTS.TASKS.GET_SALES_ACTIVITY_TYPE}`;
const GetAll_permissionByModule_Code = `${API_BASE}${API_ENDPOINTS.COMMON.GET_ALL_PERMISSION_BY_MODULE_CODE}`;

const FOR_OWNER = `${API_BASE}${API_ENDPOINTS.APPOINTMENTS.GET_USER_HIRERARCHY_LIST}`;
const Get_Collabrator = `${API_BASE}${API_ENDPOINTS.APPOINTMENTS.GET_USERLIST_PHYSICALAPP_VIEW}`;
const REMOVE_TASK_ENDPOINT = `${API_BASE}${API_ENDPOINTS.TASKS.DELETE_TASK}`;

const GET_Collabrator = `${NEWV3_BASE_URL}${API_ENDPOINTS.INVOICE.GET_OWNER_DROPDOWN}`;
const Save_Mark_As_Complete = `${API_BASE}${API_ENDPOINTS.TASKS.SAVE_MARK_AS_COMPLETE}`;

const Add_Comment = `${API_BASE}${API_ENDPOINTS.TASKS.ADD_COMMENT}`;
const Export_Doc_URL = `${API_BASE}${API_ENDPOINTS.TASKS.EXPORT_DOC}`;
const Mass_Update_API = `${API_BASE}${API_ENDPOINTS.TASKS.MASS_UPDATE_SAVE}`;
const GetUserFromHashed_List = `${WCF_BASE}${API_ENDPOINTS.PIPELINE.FOR_OWNER}`;
const Get_Duplicate_Enquiry = `${WCF_BASE}${API_ENDPOINTS.ENQUIRIES.GET_DUPLICATE_ENQUIRY}`;
const GET_APPOINTMENT_LIST = `${NEWV3_BASE_URL}${API_ENDPOINTS.TASKS.GET_TASK_HISTORY_FOR_DETAILS_EDIT}`;
const GET_SCORECARD_STATS = `${API_BASE}${API_ENDPOINTS.DASHBOARD.GET_SCORECARD_DETAILS_APPOINTMENT}`;

const AppointmentModule = () => {
    const { permissions } = usePermissions('PAG10035');
    const { maskObject, isHiddenField } = useFieldMasking('PAG10372#PAG10035');
    const crmOperationPerms = useMemo(() => {
        if (!permissions || !Array.isArray(permissions)) return null;
        return permissions.find(p => p.ModuleCode?.includes('PAG10035')) || {};
    }, [permissions]);

    const location = useLocation();
    const navigate = useNavigate();

    // Core State
    const [tasks, setTasks] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [viewMode, setViewMode] = useState('table');
    const [loading, setLoading] = useState(true);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [customSearchId, setCustomSearchId] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [calendarView, setCalendarView] = useState('month');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 25;
    const [dashboardFilter, setDashboardFilter] = useState(location.state?.dashboardFilter || '');
    const [dashboardFilterLabel, setDashboardFilterLabel] = useState(location.state?.filterLabel || '');
    const [appointmentStatusFilter, setAppointmentStatusFilter] = useState(['All']);
    const [globalStats, setGlobalStats] = useState({ total: 0, completed: 0, overdue: 0, open: 0 });
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [viewingLeadId, setViewingLeadId] = useState(null);
    const [isDetailOpen, setIsDetailOpen] = useState(false);

    const [detailMode, setDetailMode] = useState('view');

    // --- Advanced Filter States ---
    const [advancedFilters, setAdvancedFilters] = useState(null);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isCustomDownloadOpen, setIsCustomDownloadOpen] = useState(false);
    const [customExportFields, setCustomExportFields] = useState([]);
    const [customSettings, setCustomSettings] = useState([]);
    const [selectedExportFields, setSelectedExportFields] = useState([]);
    const [selectedCustomSetting, setSelectedCustomSetting] = useState('');
    const [exportSettingName, setExportSettingName] = useState('');
    const [isDownloading, setIsDownloading] = useState(false);
    const [fieldSearchTerm, setFieldSearchTerm] = useState('');

    const buildFilterText = () => {
        const searchParams = new URLSearchParams(location.search);
        const fromDate = searchParams.get('FromDate');
        const toDate = searchParams.get('ToDate');
        const exec = searchParams.get('Executive');
        const isOpen = searchParams.get('Open');
        const isOverdue = searchParams.get('Overdue');
        const filterLabel = location.state?.filterLabel || '';

        if (fromDate || toDate || (exec && (isOpen === 'true' || isOverdue === 'true'))) {
            let filterParts = [];

            if (isOpen === 'true' || isOverdue === 'true') {
                filterParts.push("(  Status = 'open'  or TaskStatus = 'Over Due'  )");
            }

            let isExecutiveClick = false;
            if (fromDate && toDate) {
                // Formatting date exactly as the user specified
                filterParts.push(`( (  (enddate between convert(date,'${fromDate}') and convert(date,'${toDate}')) ) )`);
            } else {
                filterParts.push(`( ( 1 = 1 ) )`);
                isExecutiveClick = true; // Executive click doesn't pass dates
            }

            const uId = localStorage.getItem('userId') || '34594';
            let targetUserId = location.state?.execId || uId;
            if (typeof targetUserId === 'string' && targetUserId.includes(',')) {
                targetUserId = targetUserId.split(',')[1].trim();
            }

            if (isExecutiveClick || filterLabel.startsWith('Executive')) {
                filterParts.push(`( AssignedTo in (select User_id from #tbluser where User_ID='${targetUserId}' or ParentID='${targetUserId}') and isnull(outcomesid,0)=0)`);
            } else {
                filterParts.push(`( AssignedTo in (select User_id from #tbluser) and isnull(outcomesid,0)=0)`);
            }

            return " AND " + filterParts.join(" And ");
        }

        let finalFilter = dashboardFilter || '';

        if (appointmentStatusFilter.length > 0 && !appointmentStatusFilter.includes('All')) {
            let statusConditions = [];
            const openPredicate = "((TaskStatus IS NULL OR TaskStatus NOT IN ('completed', 'closed', 'Completed', 'Closed')) AND (EndDate IS NULL OR CAST(EndDate AS DATETIME) >= GETDATE()))";
            const completedPredicate = "(TaskStatus IN ('completed', 'closed', 'Completed', 'Closed'))";
            const overduePredicate = "((TaskStatus IS NULL OR TaskStatus NOT IN ('completed', 'closed', 'Completed', 'Closed')) AND EndDate IS NOT NULL AND CAST(EndDate AS DATETIME) < GETDATE())";

            if (appointmentStatusFilter.includes('Open')) statusConditions.push(openPredicate);
            if (appointmentStatusFilter.includes('Completed')) statusConditions.push(completedPredicate);
            if (appointmentStatusFilter.includes('Overdue')) statusConditions.push(overduePredicate);

            if (statusConditions.length > 0) {
                finalFilter += ` AND (${statusConditions.join(' OR ')})`;
            }
        }
        return finalFilter;
    };

    // --- Export Handler (Appointment) ---
    const handleExportDocuments = async () => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const payload = {
                Token: "-2295521862261168",
                Details: {
                    UserId: parseInt(userId, 10),
                    FilterText: buildFilterText(),
                    Mode: "A",          // 'A' = Appointment
                    IsAdmin: false,
                    CriteriaName: searchTerm || ""
                }
            };

            Swal.fire({
                title: 'Exporting...',
                text: 'Please wait while we prepare your document',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const resp = await axios.post(Export_Doc_URL, payload);

            if (resp.data?.Status === 1 && resp.data?.Details) {
                const fileName = resp.data.Details;

                // ✅ Confirmed path (HTTP 200 from probe): SalesTarget/ExportFiles/
                const downloadUrl = `https://serviceskit19.azurewebsites.net/SalesTarget/ExportFiles/${fileName}`;

                window.open(downloadUrl, '_blank');

                Swal.fire({
                    icon: 'success',
                    title: 'Export Successful',
                    text: 'Your file download has started.',
                    timer: 2000,
                    showConfirmButton: false
                });
            } else {
                Swal.fire('Error', resp.data?.Message || 'Failed to export documents', 'error');
            }
        } catch (err) {
            console.error('Export error:', err);
            Swal.fire('Error', 'An error occurred during export', 'error');
        }
    };
    // Client-side CSV Export (Matching TaskModule functionality)
    const handleExportToCSV = () => {
        if (!strictlyFilteredTasks || strictlyFilteredTasks.length === 0) {
            Swal.fire('Info', 'No appointments to export.', 'info');
            return;
        }

        const columns = [
            { header: 'LeadNo', key: 'leadId' },
            { header: 'Title', key: 'taskTitle' },
            { header: 'Description', key: 'description' },
            { header: 'Contact Name', key: 'name' },
            { header: 'Phone', key: 'phone' },
            { header: 'Start Date', key: 'startDate' },
            { header: 'End Date', key: 'endDate' },
            { header: 'Status', key: 'taskStatus' },
            { header: 'Owner', key: 'ownerName' },
            { header: 'Creator', key: 'creatorName' },
            { header: 'Outcome', key: 'outcomeName' },
            { header: 'Address', key: 'Where' }
        ];

        const headers = columns.map(col => col.header);

        // Helper to format date for CSV (dd-MMM-yy) to avoid ##### in Excel
        const formatExcelDate = (dateString) => {
            if (!dateString || dateString === '0' || dateString === 'null') return '';
            const date = parseCustomDate(dateString);
            if (!date || isNaN(date.getTime()) || date.getFullYear() < 1900) return '';
            return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' }).replace(/ /g, '-');
        };

        // Helper to escape CSV values and add spacing for Excel
        const escapeCSV = (val) => {
            if (val === null || val === undefined) return '""';
            let str = String(val).replace(/"/g, '""');
            // Adding a leading space (" " + str) provides visual spacing in Excel 
            // and prevents auto-formatting of large numbers/dates
            return `" ${str}"`;
        };

        const headerRow = headers.map(h => `"${h}"`).join(",");
        const dataRows = strictlyFilteredTasks.map(appt => {
            const maskedAppt = maskObject({ ...appt });
            return columns.map(col => {
                let val = maskedAppt[col.key];
                if (col.key === 'startDate' || col.key === 'endDate') {
                    val = formatExcelDate(val);
                }
                return escapeCSV(val);
            }).join(',');
        });

        const csvContent = [headerRow, ...dataRows].join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `Appointments_Export_${new Date().toISOString().slice(0, 10)}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            Swal.fire('Success', 'Export Downloaded Successfully!', 'success');
        }
    };

    // --- Custom Export Data Fetching ---
    useEffect(() => {
        if (isCustomDownloadOpen) {
            const fetchCustomExportData = async () => {
                const uid = localStorage.getItem('userId') || '34594';
                const token = API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN.toString();

                // 1. Fetch Placeholders
                try {
                    const NEWV3_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
                    const phUrl = `${NEWV3_BASE_URL}/UserCRM/FuncToGetEntityPlaceHolder`;
                    const res = await fetch(phUrl, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ Token: token, Details: { strEntityName: "Lead", strParentID: uid } })
                    });
                    const result = await res.json();
                    if (result && result.Status === 1 && result.Details) {
                        setCustomExportFields(result.Details);
                    } else if (result && result.d) {
                        setCustomExportFields(result.d);
                    }
                } catch (e) { console.error('Error fetching placeholders:', e); }

                // 2. Fetch Settings
                try {
                    const settingsUrl = `${API_BASE}${API_ENDPOINTS.COMMON.EXPORT_DATA_SETTING}`;
                    const payload = {
                        Details: {
                            Id: 0,
                            SettingName: "",
                            PageUrl: "/UserCRMCampaign/ToDo/appointment.aspx",
                            CsvColumns: "",
                            Section: "Appointment",
                            EntityName: "Entity",
                            UserId: uid,
                            Mode: "get"
                        },
                        Token: token
                    };
                    const res = await fetch(settingsUrl, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payload)
                    });
                    const result = await res.json();
                    if (result && result.Details && result.Details.data) {
                        setCustomSettings(result.Details.data);
                    } else if (result && result.data) {
                        setCustomSettings(result.data);
                    }
                } catch (e) { console.error('Error fetching settings:', e); }
            };
            fetchCustomExportData();
        }
    }, [isCustomDownloadOpen]);



    const handleSaveExportSetting = async () => {
        let nameToSave = exportSettingName;
        let existingId = 0;

        if (!nameToSave && selectedCustomSetting) {
            const currentSetting = customSettings.find(s => s.Id.toString() === selectedCustomSetting);
            if (currentSetting) {
                nameToSave = currentSetting.SettingName;
                existingId = currentSetting.Id;
            }
        }

        if (!nameToSave || selectedExportFields.length === 0) {
            alert("Please enter a name for the setting and select at least one field.");
            return;
        }

        const uid = localStorage.getItem('userId') || '34594';
        const token = API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN.toString();
        try {
            const payload = {
                Details: {
                    Id: existingId,
                    SettingName: nameToSave,
                    PageUrl: "/UserCRMCampaign/ToDo/appointment.aspx",
                    CsvColumns: selectedExportFields.join(','),
                    Section: "Appointment",
                    EntityName: "Lead",
                    UserId: uid,
                    Mode: "set"
                },
                Token: token
            };

            const settingsUrl = `${API_BASE}${API_ENDPOINTS.COMMON.EXPORT_DATA_SETTING}`;
            const res = await fetch(settingsUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const result = await res.json();

            if (result && (result.Status === 1 || (result.Details && result.Details.Status === 1))) {
                alert("Setting saved successfully!");
                setExportSettingName('');
                // Re-fetch
                const fetchSettingsAfterSave = async () => {
                    const sPayload = {
                        Details: {
                            Id: 0,
                            SettingName: "",
                            PageUrl: "/UserCRMCampaign/ToDo/appointment.aspx",
                            CsvColumns: "",
                            Section: "Appointment",
                            EntityName: "Entity",
                            UserId: uid,
                            Mode: "get"
                        },
                        Token: token
                    };
                    try {
                        const sRes = await fetch(settingsUrl, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(sPayload)
                        });
                        const sResult = await sRes.json();
                        if (sResult && sResult.Details && sResult.Details.data) {
                            setCustomSettings(sResult.Details.data);
                        } else if (sResult && sResult.data) {
                            setCustomSettings(sResult.data);
                        }
                    } catch (e) {
                        console.error('Error re-fetching settings after save:', e);
                    }
                };
                fetchSettingsAfterSave();
            } else {
                const msg = (result && (result.Message || result.MessageText)) || 'Failed to save';
                alert("Failed to save: " + msg);
            }
        } catch (e) {
            console.error('Error saving setting:', e);
            alert("Error saving setting. Check console.");
        }
    };


    const handleCustomDownloadSubmit = async () => {
        if (selectedExportFields.length === 0) {
            alert("Please select at least one field.");
            return;
        }
        setIsDownloading(true);
        const uid = localStorage.getItem('userId') || '34594';

        try {
            const payload = {
                UserId: uid,
                EntityName: "Lead",
                PageMode: "Appointment",
                Mode: "A",
                CriteriaName: searchTerm || "",
                FilterText: buildFilterText(),
                csvColumnList: selectedExportFields.join(','),
                PageSection: "Appointment",
                FollowUpType: "AssignedTo",
                AssignedTo: "0",
                CreatedBy: "",
                NextStatusFromDate: "",
                NextStatusToDate: "",
                CreatedFromDate: "",
                CreatedToDate: "",
                LeadId: "0",
                Remarks: "",
                Overdue: "false",
                DueToday: "false",
                Scheduled: "false",
                NoFollowUp: "false",
                IsReAssign: "false"
            };

            const form = document.createElement('form');
            form.method = 'POST';
            form.action = 'https://wcfkit19.azurewebsites.net/UserCRMCampaign/Service/CallReportService.asmx/ExportWidgetDownload';
            form.target = '_blank';

            Object.keys(payload).forEach(key => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = payload[key];
                form.appendChild(input);
            });

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);

        } catch (e) {
            console.error('Export error:', e);
            alert("An error occurred during download.");
        } finally {
            setIsDownloading(false);
        }
    };


    const appointmentFields = [
        { label: 'Title', value: 'taskTitle' },
        { label: 'Description', value: 'description' },
        { label: 'Related To', value: 'name' },
        { label: 'Enquiry ID', value: 'enquiryId' },
        { label: 'Status', value: 'statusLabel' },
        { label: 'Due Date', value: 'startDate', type: 'date' },
        { label: 'Created On', value: 'createdDate', type: 'date' },
        { label: 'Owner', value: 'ownerName' }
    ];

    const handleAdvancedFilterSubmit = (newFilters) => {
        setAdvancedFilters(prev => ({ ...newFilters, sortBy: prev?.sortBy || 'created_desc' }));
        setCurrentPage(1);
    };

    // Centralized parseCustomDate is now imported from utils/dateUtils

    // Modal & Side Panel States
    const [isOutcomeModalOpen, setIsOutcomeModalOpen] = useState(false);
    const [outcomesList, setOutcomesList] = useState([]);
    const [selectedOutcome, setSelectedOutcome] = useState('');
    const [outcomeRemarks, setOutcomeRemarks] = useState('');
    const [markingTask, setMarkingTask] = useState(null);
    const [isMarkingComplete, setIsMarkingComplete] = useState(false);

    // Grid Detail Panel State (Internalized for Parity with Image 2)
    const [gridTaskDetail, setGridTaskDetail] = useState(null);
    const [gridComments, setGridComments] = useState([]);
    const [isGridDetailLoading, setIsGridDetailLoading] = useState(false);
    const [isGridCommentsLoading, setIsGridCommentsLoading] = useState(false);
    const [newGridComment, setNewGridComment] = useState('');
    const [gridCommentFile, setGridCommentFile] = useState(null);
    const [gridCommentFileName, setGridCommentFileName] = useState('');
    const [isSubmittingComment, setIsSubmittingComment] = useState(false);

    const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
    const [selectedAppointmentForComment, setSelectedAppointmentForComment] = useState(null);
    const [commentText, setCommentText] = useState('');
    const [commentFile, setCommentFile] = useState(null);
    const [commentFileName, setCommentFileName] = useState('');
    const [isSavingComment, setIsSavingComment] = useState(false);

    const [rowSelection, setRowSelection] = useState({});
    const [showMassDrawer, setShowMassDrawer] = useState(false);
    const [activeOperationMode, setActiveOperationMode] = useState('followup');
    const [selectedIds, setSelectedIds] = useState(new Set()); // Legacy, keeping for safety

    const handleCommentClick = (task) => {
        setSelectedAppointmentForComment(task);
        setCommentText('');
        setCommentFile(null);
        setCommentFileName('');
        setIsCommentModalOpen(true);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setCommentFile(file);
            setCommentFileName(file.name);
        }
    };

    const handleSaveComment = async () => {
        if (!commentText.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Comment Required',
                text: 'Please enter a comment before saving.',
                confirmButtonColor: '#10b981'
            });
            return;
        }

        setIsSavingComment(true);
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const appointmentId = selectedAppointmentForComment?.id || selectedAppointmentForComment?.Id || selectedAppointmentForComment?.TaskHistoryId;

            const details = {
                Token: "-2295521862261168",
                taskAttachment: {
                    Remarks: commentText,
                    CreatedBy: parseInt(uid),
                    TaskId: parseInt(appointmentId),
                    ParentId: parseInt(uid),
                    Mode: "C"
                }
            };

            const formData = new FormData();
            formData.append('details', JSON.stringify(details));
            if (commentFile) {
                formData.append('file', commentFile);
            }

            const response = await fetch(Add_Comment, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Comment Added',
                    text: 'Your comment has been saved successfully.',
                    timer: 2000,
                    showConfirmButton: false
                });
                setIsCommentModalOpen(false);
            } else {
                throw new Error('Failed to save comment');
            }
        } catch (error) {
            console.error('Error saving comment:', error);
            Swal.fire({
                icon: 'error',
                title: 'Save Failed',
                text: 'Could not save your comment. Please try again.',
                confirmButtonColor: '#ef4444'
            });
        } finally {
            setIsSavingComment(false);
        }
    };

    const [showMassUpdatePanel, setShowMassUpdatePanel] = useState(false);
    const [massSubmitting, setMassSubmitting] = useState(false);
    const [massUpdateData, setMassUpdateData] = useState({
        Description: '', Remarks: '', StartDate: '', EndDate: '', Where: '',
        Owner: '', CompleteAddress: '', Latitude: '', Longitude: '',
        MarkAsCompleted: false, OutcomeId: '0'
    });
    const [massOwnerOptions, setMassOwnerOptions] = useState([]);
    const [massCollabOptions, setMassCollabOptions] = useState([]);
    const [massSelectedCollabs, setMassSelectedCollabs] = useState([]);
    const [massCollabSearch, setMassCollabSearch] = useState('');
    const [massCollabDropdownOpen, setMassCollabDropdownOpen] = useState(false);
    const massCollabRef = useRef(null);
    const [toast, setToast] = useState(null);
    const [showAddAppointmentModal, setShowAddAppointmentModal] = useState(false);
    const [appointmentToEdit, setAppointmentToEdit] = useState(null);

    const [scriptsLoaded, setScriptsLoaded] = useState(false);
    const whereInputRef = useRef(null);
    const autocompleteRef = useRef(null);

    const editCollabRef = useRef(null);
    const editOutcomeRef = useRef(null);
    const editRelatedRef = useRef(null);

    const [editCollabDropdownOpen, setEditCollabDropdownOpen] = useState(false);
    const [editOutcomeDropdownOpen, setEditOutcomeDropdownOpen] = useState(false);
    const [editRelatedDropdownOpen, setEditRelatedDropdownOpen] = useState(false);

    useEffect(() => {
        const handler = (e) => {
            if (e.type === 'scroll') {
                window.dispatchEvent(new CustomEvent('close-all-option-menus'));
                setEditCollabDropdownOpen(false);
                setEditOutcomeDropdownOpen(false);
                setEditRelatedDropdownOpen(false);
                setMassCollabDropdownOpen(false);
                return;
            }
            if (editCollabRef.current && !editCollabRef.current.contains(e.target)) setEditCollabDropdownOpen(false);
            if (editOutcomeRef.current && !editOutcomeRef.current.contains(e.target)) setEditOutcomeDropdownOpen(false);
            if (editRelatedRef.current && !editRelatedRef.current.contains(e.target)) setEditRelatedDropdownOpen(false);
            if (massCollabRef.current && !massCollabRef.current.contains(e.target)) setMassCollabDropdownOpen(false);
        };
        document.addEventListener('mousedown', handler);
        window.addEventListener('scroll', handler, true);
        return () => {
            document.removeEventListener('mousedown', handler);
            window.removeEventListener('scroll', handler, true);
        };
    }, []);

    useEffect(() => {
        const scriptId = 'google-maps-script';
        const isGoogleMapsReady = () => window.google && window.google.maps && window.google.maps.places;

        if (isGoogleMapsReady()) {
            setScriptsLoaded(true);
            return;
        }

        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAO-dLMQIXYLvJeig0dbjeEqytvPg6EMd8&libraries=places&loading=async&callback=initGoogleMapsCallback`;
            script.async = true;
            script.defer = true;
            window.initGoogleMapsCallback = () => {
                setScriptsLoaded(true);
                // Inject global Z-index fix for Google Autocomplete suggestions
                const style = document.createElement('style');
                style.innerHTML = '.pac-container { z-index: 100000 !important; }';
                document.head.appendChild(style);
            };
            script.onerror = () => console.error("Google Maps script failed to load");
            document.body.appendChild(script);
        } else {
            const checkInterval = setInterval(() => {
                if (isGoogleMapsReady()) {
                    window.initGoogleMapsCallback = () => {
                        setScriptsLoaded(true);
                        // Inject global Z-index fix for Google Autocomplete suggestions
                        if (!document.querySelector('style#pac-fix')) {
                            const style = document.createElement('style');
                            style.id = 'pac-fix';
                            style.innerHTML = '.pac-container { z-index: 9999999 !important; }';
                            document.head.appendChild(style);
                        }
                    };
                    clearInterval(checkInterval);
                }
            }, 100);
            setTimeout(() => clearInterval(checkInterval), 10000);
        }
    }, []);

    useEffect(() => {
        if (scriptsLoaded && showMassUpdatePanel && whereInputRef.current) {
            autocompleteRef.current = new window.google.maps.places.Autocomplete(whereInputRef.current, {
                types: ['geocode', 'establishment'],
            });

            autocompleteRef.current.addListener('place_changed', () => {
                const place = autocompleteRef.current.getPlace();
                if (place && place.formatted_address) {
                    setMassUpdateData(prev => ({
                        ...prev,
                        Where: place.name || place.formatted_address,
                        CompleteAddress: place.formatted_address,
                        Latitude: place.geometry?.location?.lat()?.toString() || "",
                        Longitude: place.geometry?.location?.lng()?.toString() || ""
                    }));
                }
            });
        }
    }, [scriptsLoaded, showMassUpdatePanel]);

    const fetchMassOptions = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const payload = { Token: "-2295521862261168", Details: { UserId: parseInt(uid, 10) } };
            const [ownersRes, collabsRes] = await Promise.all([
                fetch(GET_Collabrator, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                }),
                fetch(GET_Collabrator, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                })
            ]);
            const owners = await ownersRes.json();
            const collabs = await collabsRes.json();
            const rawOwners = owners?.Status === 1 && owners?.Details ? owners.Details : (owners?.d || owners?.Data || owners?.data || owners || []);
            const rawCollabs = collabs?.Status === 1 && collabs?.Details ? collabs.Details : (collabs?.d || collabs?.Data || collabs?.data || collabs || []);

            let parsedOwners = Array.isArray(rawOwners) ? rawOwners : [];
            if (typeof rawOwners === 'string') { try { parsedOwners = JSON.parse(rawOwners); } catch (e) { } }

            let parsedCollabs = Array.isArray(rawCollabs) ? rawCollabs : [];
            if (typeof rawCollabs === 'string') { try { parsedCollabs = JSON.parse(rawCollabs); } catch (e) { } }

            setMassOwnerOptions(Array.isArray(parsedOwners) ? parsedOwners : []);
            setMassCollabOptions(Array.isArray(parsedCollabs) ? parsedCollabs : []);
        } catch (e) { console.error('Error fetching mass options:', e); }
    };

    useEffect(() => {
        if (showMassUpdatePanel) {
            fetchMassOptions();
        }
    }, [showMassUpdatePanel]);

    const [isEditPanelOpen, setIsEditPanelOpen] = useState(false);
    const [selectedEntity, setSelectedEntity] = useState(null);

    const [allIds, setAllIds] = useState([]);
    const [isAllSelectedAcrossPages, setIsAllSelectedAcrossPages] = useState(false);

    const fetchAllSelectedIds = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const payload = {
                Token: -2295521862261168,
                Details: { UserID: parseInt(uid), Mode: "A", OffsetValue: 0, PagingSize: totalRecords, FilterText: dashboardFilter || "" }
            };
            const res = await fetch(GET_APPOINTMENTS_API, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const raw = await res.json();
            const d = raw.d ? (typeof raw.d === 'string' ? JSON.parse(raw.d) : raw.d) : (raw.Details || raw);
            const dataArray = d?.Details?.data || d?.data || [];
            return dataArray.map(item => item.id || item.TaskHistoryId || item.Id || item.ID);
        } catch (e) {
            console.error('Error fetching all selected IDs:', e);
            return [];
        }
    };
    const handleRowSelectionChange = (newSelection) => {
        const selectedCountOnPage = Object.keys(newSelection).filter(k => newSelection[k]).length;
        const itemsOnPage = currentViewData.length;

        if (selectedCountOnPage === itemsOnPage && itemsOnPage > 1) {
            if (!isAllSelectedAcrossPages) setIsAllSelectedAcrossPages(true);
        } else {
            if (isAllSelectedAcrossPages) setIsAllSelectedAcrossPages(false);
            if (allIds.length > 0) setAllIds([]);
        }
        setRowSelection(newSelection);
    };

    const handleMassAction = async (actionId) => {
        if (!actionId) return;

        if (actionId === 'mass_update' && crmOperationPerms && !crmOperationPerms.MassUpdate) {
            Swal.fire('Access Denied', "You don't have permission to perform mass updates.", 'warning');
            return;
        }
        if (actionId === 'delete' && crmOperationPerms && !crmOperationPerms.MassDelete) {
            Swal.fire('Access Denied', "You don't have permission to perform mass deletion.", 'warning');
            return;
        }
        if (actionId === 'mass_sms' && crmOperationPerms && !crmOperationPerms.MassSMS) {
            Swal.fire('Access Denied', "You don't have permission to perform mass SMS.", 'warning');
            return;
        }
        if (actionId === 'mass_email' && crmOperationPerms && !crmOperationPerms.MassEmail) {
            Swal.fire('Access Denied', "You don't have permission to perform mass Email.", 'warning');
            return;
        }
        if (actionId === 'mass_assign' && crmOperationPerms && !crmOperationPerms.MassAssign) {
            Swal.fire('Access Denied', "You don't have permission to perform mass Assignment.", 'warning');
            return;
        }
        if (actionId === 'mass_broadcast' && crmOperationPerms && !crmOperationPerms.MassBroadcast) {
            Swal.fire('Access Denied', "You don't have permission to perform mass Broadcast.", 'warning');
            return;
        }

        if (isAllSelectedAcrossPages && allIds.length === 0) {
            setMassSubmitting(true);
            const ids = await fetchAllSelectedIds();
            setAllIds(ids);
            setMassSubmitting(false);
        }

        if (actionId === 'mass_update') {
            setShowMassUpdatePanel(true);
        } else {
            setActiveOperationMode(actionId);
            setShowMassDrawer(true);
        }
    };

    const selectedCount = useMemo(() => {
        if (isAllSelectedAcrossPages) return totalRecords;
        return Object.keys(rowSelection).filter(k => rowSelection[k]).length;
    }, [rowSelection, isAllSelectedAcrossPages, totalRecords]);


    // Pure Helpers (Moved outside to prevent re-creation)
    const getAvatar = (params) => {
        const { avatar, name, threshold, showBadge = true } = params;
        const scheme = getAvatarColorScheme(name);
        const initials = getInitials(name || 'Unknown');
        const hasValidAvatar = avatar && !isGenericAvatar(avatar);

        // Ensure threshold is a numeric count (Image 2 parity)
        const numericThreshold = (typeof threshold === 'number') ? threshold : parseInt(String(threshold).replace(/[^\d]/g, ''), 10) || 0;

        return (
            <div className='related-avatar-group' style={{ position: 'relative', width: 38, height: 38 }}>
                <CustomAvatar
                    src={hasValidAvatar ? avatar : undefined}
                    sx={{
                        width: 38, height: 38, fontSize: '15px', fontWeight: 600,
                        backgroundColor: scheme.bg, color: scheme.text,
                        border: '2px solid #fff', boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                        zIndex: 1
                    }}
                >
                    {initials}
                </CustomAvatar>
                {showBadge && (
                    <div className='lead-score-badge' style={{ zIndex: 10 }}>
                        {numericThreshold}
                    </div>
                )}
            </div>
        );
    };

    const formatDateDisplay = (dateStr) => {
        if (!dateStr) return '--';
        const d = parseCustomDate ? parseCustomDate(dateStr) : new Date(dateStr);
        if (!d || isNaN(d.getTime())) return typeof dateStr === 'string' ? dateStr : '--';

        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const day = d.getDate();
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        const hh = String(d.getHours()).padStart(2, '0');
        const mm = String(d.getMinutes()).padStart(2, '0');

        return `${day}-${month}-${year} ${hh}:${mm}`;
    };

    const formatDateTimeDisplay = (dateTimeStr) => {
        if (!dateTimeStr) return "";
        try {
            const d = new Date(dateTimeStr);
            if (isNaN(d.getTime())) return "";
            const monthsAbbr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const datePart = `${d.getDate().toString().padStart(2, '0')}-${monthsAbbr[d.getMonth()]}-${d.getFullYear()}`;
            const timePart = `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
            return `${datePart} ${timePart}`;
        } catch (e) { return ""; }
    };

    const getLocalISO = () => {
        const now = new Date();
        const tzOffset = now.getTimezoneOffset() * 60000;
        return (new Date(now - tzOffset)).toISOString().slice(0, 16);
    };

    const resetMassUpdateForm = () => {
        setMassUpdateData({
            Description: '', Remarks: '', StartDate: '', EndDate: '', Where: '',
            Owner: '', CompleteAddress: '', Latitude: '', Longitude: '',
            MarkAsCompleted: false, OutcomeId: '0'
        });
        setMassSelectedCollabs([]);
        setMassCollabSearch('');
    };

    const renderCalendarEvent = useCallback((event) => {
        const taskStatus = (event.taskStatus || event.status || 'Open').toLowerCase();
        const isCompleted = taskStatus === 'completed' || taskStatus === 'closed';
        const dueDate = event.endDate || event.date || "";
        const dueDateObj = parseCustomDate(dueDate);
        const today = new Date().setHours(0, 0, 0, 0);
        const isOverdue = !isCompleted && dueDateObj && dueDateObj < today;
        const isUpcoming = !isCompleted && !isOverdue && dueDateObj;

        let statusType = 'open';
        if (isCompleted) statusType = 'completed';
        else if (isOverdue) statusType = 'overdue';
        else if (isUpcoming) statusType = 'upcoming';

        const cleanTitle = (event.title || event.taskTitle || 'No Title')?.replace(/#\d+\s*/g, '').trim();
        const isMonthlyView = calendarView === 'month';

        return (
            <div
                key={event.id}
                className={`calendar-card-modern ${statusType} ${isMonthlyView ? 'monthly-compact' : ''}`}
                onClick={(e) => { e.stopPropagation(); handleCalendarEventClick(event); }}
            >
                <div
                    className="calendar-card-title link-style"
                    title={cleanTitle}
                    onClick={(e) => { e.stopPropagation(); handleCalendarEventClick(event); }}
                >
                    {cleanTitle}
                </div>
                <div className="calendar-card-footer">
                    <div className="calendar-footer-profiles">
                        <div
                            className="calendar-profile-item clickable-lead-link hyperlink"
                            title={`Related: ${event.name}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (event.enquiryId) {
                                    setViewingLeadId(event.enquiryId);
                                }
                            }}
                        >
                            <div className="calendar-avatar-mini">{getInitials(event.name)}</div>
                            <span className="calendar-user-name-mini link-style">{event.name}</span>
                        </div>
                        <div className="calendar-profile-item owner" title={`Owner: ${event.ownerName}`}>
                            <div className="calendar-avatar-mini outline-icon">
                                <UserIcon size={12} strokeWidth={2.5} />
                            </div>
                            <span className="calendar-user-name-mini">{event.ownerName}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }, [calendarView]);

    // --- Logical Handlers for Grid Detail Panel ---
    const fetchGridTaskDetail = async (appt) => {
        const appointmentId = appt?.id || appt?.Id || appt?.TaskHistoryId || appt?.taskId;
        if (!appointmentId) return;

        try {
            setIsGridDetailLoading(true);
            const payload = { Token: "-2295521862261168", Details: { Id: parseInt(appointmentId, 10) } };

            const response = await fetch(GetAppointment_Details, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result.Status === 1 && result.Details) setGridTaskDetail(result.Details);
            }
        } catch (error) {
            console.error('[AppointmentModule] fetchGridTaskDetail error:', error);
        } finally {
            setIsGridDetailLoading(false);
        }
    };

    const fetchGridComments = async (appt) => {
        const appointmentId = appt?.id || appt?.Id || appt?.TaskHistoryId || appt?.taskId;
        if (!appointmentId) return;

        try {
            setIsGridCommentsLoading(true);
            const payload = { Id: parseInt(appointmentId, 10) };

            const response = await fetch(GET_GRID_COMMENTS, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result.d) {
                    try {
                        const parsed = typeof result.d === 'string' ? JSON.parse(result.d) : result.d;
                        setGridComments(Array.isArray(parsed) ? parsed : []);
                    } catch (e) { setGridComments([]); }
                }
            }
        } catch (error) {
            console.error("[AppointmentModule] fetchGridComments error:", error);
        } finally {
            setIsGridCommentsLoading(false);
        }
    };

    const handleRowAction = useCallback((task, actionType) => {
        if (actionType === 'delete' || actionType === 'remove') {
            handleRemoveTask(task.id);
            return;
        }

        const modeMap = {
            'followup': 'followup', 'mail': 'send-mail',
            'sms': 'send-sms', 'voice': 'send-voice',
            'notes': 'add-notes', 'upload': 'upload-document',
            'addtask': 'add-task', 'addappointment': 'add-appointment',
            'adddeal': 'add-deal', 'fillWebform': 'fill-webform'
        };

        const mode = modeMap[actionType] || 'view';
        setSelectedAppointment(task);
        setDetailMode(mode);
        setIsDetailOpen(true);
    }, []);

    const handleAddGridComment = async () => {
        if (!newGridComment.trim() && !gridCommentFile || !selectedAppointment) return;

        try {
            setIsSubmittingComment(true);
            const userId = localStorage.getItem('userId') || '34594';
            const taskId = selectedAppointment.id || selectedAppointment.Id || selectedAppointment.taskId;

            const details = {
                Token: "-2295521862261168",
                taskAttachment: {
                    Remarks: newGridComment,
                    CreatedBy: parseInt(userId, 10),
                    TaskId: parseInt(taskId, 10),
                    ParentId: parseInt(userId, 10),
                    Mode: "C"
                }
            };

            const formData = new FormData();
            formData.append('details', JSON.stringify(details));
            if (gridCommentFile) {
                formData.append('file', gridCommentFile);
            }

            const response = await fetch(Add_Comment, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
            });

            if (response.ok) {
                const result = await response.json();
                if (result.Status === 1 || result.Message === "Success" || result.d === "Success") {
                    setNewGridComment('');
                    setGridCommentFile(null);
                    setGridCommentFileName('');
                    fetchGridComments(selectedAppointment);
                }
            }
        } catch (error) {
            console.error("[AppointmentModule] handleAddGridComment error:", error);
        } finally {
            setIsSubmittingComment(false);
        }
    };

    useEffect(() => {
        if (selectedAppointment && viewMode === 'grid') {
            fetchGridTaskDetail(selectedAppointment);
            fetchGridComments(selectedAppointment);
        } else {
            setGridTaskDetail(null);
            setGridComments([]);
        }
    }, [selectedAppointment, viewMode]);

    // --- Logical Handlers ---


    const handleRemoveTask = useCallback(async (taskId) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, remove it!'
        });

        if (result.isConfirmed) {
            try {
                const uid = localStorage.getItem('userId') || '34594';
                const payload = {
                    Token: "-2295521862261168",
                    Details: { Id: parseInt(taskId), UserId: parseInt(uid) }
                };
                const resp = await fetch(REMOVE_TASK_ENDPOINT, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                });
                if (resp.ok) {
                    setTasks(prev => prev.filter(t => t.id !== taskId));
                    fetchInitialCounts(true);
                    Swal.fire({
                        title: 'Removed!',
                        text: 'Your appointment has been removed.',
                        icon: 'success',
                        confirmButtonColor: '#7c3aed' // Matching the purple from Image 3
                    });
                }
            } catch (err) {
                console.error(err);
                Swal.fire('Error', 'Failed to remove appointment.', 'error');
            }
        }
    }, []);

    const handleMarkAsCompletedClick = useCallback(async (task) => {
        setMarkingTask(task);
        setIsOutcomeModalOpen(true);
        try {
            const response = await fetch(GetAppointment_Details, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: '-2295521862261168', Details: { Id: parseInt(task.TaskHistoryId || task.id, 10) } })
            });
            const data = await response.json();
            let outcomes = [];
            if (data?.Status === 1 && data?.Details) {
                const inner = data.Details;
                outcomes = inner?.Outcomes || inner?.OutcomeList || inner?.Table1 || [];
            }
            setOutcomesList(outcomes);
        } catch (e) { console.error(e); }
    }, []);

    const handleMarkAsCompletedSubmit = async () => {
        if (!selectedOutcome) {
            Swal.fire({
                title: 'Error',
                text: 'Please select an outcome',
                icon: 'error',
                confirmButtonColor: '#7c3aed'
            });
            return;
        }

        setIsMarkingComplete(true);
        try {
            const payload = {
                Token: "-2295521862261168",
                Details: {
                    Id: parseInt(markingTask.id),
                    OutcomeId: parseInt(selectedOutcome),
                    Remarks: outcomeRemarks || "Appointment completed successfully"
                }
            };
            const response = await fetch(Save_Mark_As_Complete, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                Swal.fire({
                    title: 'Success!',
                    text: 'Appointment marked as completed!',
                    icon: 'success',
                    confirmButtonColor: '#7c3aed'
                });
                setIsOutcomeModalOpen(false);
                setSelectedOutcome('');
                setOutcomeRemarks('');
                fetchInitialCounts(true);
                fetchTasks(); // Refresh data without reload
            } else {
                Swal.fire('Error', 'Failed to update appointment.', 'error');
            }
        } catch (e) {
            console.error(e);
            Swal.fire('Error', 'An error occurred.', 'error');
        } finally {
            setIsMarkingComplete(false);
        }
    };



    const hasMassPerms = crmOperationPerms && (
        crmOperationPerms.MassUpdate || crmOperationPerms.MassDelete ||
        crmOperationPerms.MassSMS || crmOperationPerms.MassEmail ||
        crmOperationPerms.MassAssign || crmOperationPerms.MassBroadcast
    );

    const columns = useMemo(() => {
        const cols = [
            {
                id: 'select',
                header: ({ table }) => (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '40px' }} onClick={(e) => e.stopPropagation()}>
                        <Checkbox
                            size="small"
                            checked={table.getIsAllRowsSelected()}
                            indeterminate={table.getIsSomeRowsSelected()}
                            onChange={table.getToggleAllRowsSelectedHandler()}
                            sx={{ p: 0, color: '#cbd5e1', '&.Mui-checked': { color: '#00897b' }, '&.MuiCheckbox-indeterminate': { color: '#00897b' } }}
                        />
                    </Box>
                ),
                cell: ({ row }) => (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '40px' }} onClick={(e) => e.stopPropagation()}>
                        <Checkbox
                            size="small"
                            checked={row.getIsSelected()}
                            disabled={!row.getCanSelect()}
                            onChange={row.getToggleSelectedHandler()}
                            sx={{ p: 0, color: '#cbd5e1', '&.Mui-checked': { color: '#00897b' } }}
                        />
                    </Box>
                ),
                enableSorting: false,
                size: 50
            },
            {
                id: 'title',
                header: () => (
                    <Tooltip title="Sort by Appointment" arrow placement="top">
                        <span>APPOINTMENT</span>
                    </Tooltip>
                ),
                accessorKey: 'taskTitle',
                cell: ({ row }) => {
                    const statusLabel = getStatusDescriptor(
                        row.original.taskStatus, row.original.endDate, row.original.completedDate,
                        row.original.taskTitle, row.original.startDate, row.original.taskStatus,
                        row.original.outcomeName, row.original.createdDate
                    );

                    const isCompleted = statusLabel.toLowerCase().startsWith('completed');
                    const isOverdue = statusLabel.toLowerCase().startsWith('overdue');
                    const isDueToday = statusLabel.toLowerCase() === 'due today';
                    const badgeBg = isCompleted ? '#28c76f' : isOverdue ? '#ea5455' : isDueToday ? '#ff9f43' : '#3b82f6';

                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                                <Typography
                                    sx={{
                                        color: '#666cff',
                                        fontSize: '16px',
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                        textDecoration: 'underline',
                                        '&:hover': { opacity: 0.8 }
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedAppointment(row.original);
                                        setDetailMode('view');
                                        setIsDetailOpen(true);
                                    }}
                                >
                                    {row.original.taskTitle || 'No Title'}
                                </Typography>
                                <span style={{
                                    display: 'inline-flex', alignItems: 'center', background: badgeBg, color: '#fff',
                                    borderRadius: '20px', padding: '2px 10px', fontSize: '11px', fontWeight: 700,
                                    whiteSpace: 'nowrap', letterSpacing: '0.01em'
                                }}>
                                    {statusLabel}
                                </span>
                            </Box>

                            {row.original.outcomeName && (
                                <Typography sx={{ fontSize: '13px', color: '#28a745', fontWeight: 600 }}>
                                    Outcome : {row.original.outcomeName}
                                </Typography>
                            )}
                        </Box>
                    );
                }
            },
            {
                id: 'date',
                header: () => (
                    <Tooltip title="Sort by Due Date" arrow placement="top">
                        <span>DUE DATE</span>
                    </Tooltip>
                ),
                accessorKey: 'startDate',
                cell: ({ row }) => (
                    <Typography sx={{ color: '#334155', fontWeight: 600, fontSize: '14px' }}>
                        {formatDate(row.original.startDate, false)}
                    </Typography>
                )
            },
            {
                id: 'relatedTo',
                header: () => (
                    <Tooltip title="Sort by Related Entity" arrow placement="top">
                        <span>RELATED TO</span>
                    </Tooltip>
                ),
                accessorKey: 'name',
                cell: ({ row }) => (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                        <ScoreCard leadId={row.original.leadId} mobileNo={row.original.phone} personName={row.original.name}>
                            <Box sx={{ flexShrink: 0, position: 'relative', width: 42, height: 42, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                {getAvatar({ avatar: row.original.avatar, name: row.original.name, threshold: row.original.threshold, showBadge: true })}
                            </Box>
                        </ScoreCard>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Typography
                                    sx={{
                                        color: '#666cff',
                                        fontSize: '15px',
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                        textDecoration: 'underline',
                                        '&:hover': { opacity: 0.8 }
                                    }}
                                    onClick={() => setViewingLeadId(row.original.leadId)}
                                >
                                    {row.original.name}
                                </Typography>
                                {!(getStatusDescriptor(
                                    row.original.taskStatus, row.original.endDate, row.original.completedDate,
                                    row.original.taskTitle, row.original.startDate, row.original.taskStatus,
                                    row.original.outcomeName, row.original.createdDate
                                ).toLowerCase().startsWith('completed')) && (
                                        <IconButton
                                            size="small" sx={{ p: 0.5, color: '#94a3b8', '&:hover': { color: '#666cff' } }}
                                            onClick={(e) => { e.stopPropagation(); setSelectedEntity(row.original); setIsEditPanelOpen(true); }}
                                        >
                                            <LaunchIcon sx={{ fontSize: '14px' }} />
                                        </IconButton>
                                    )}
                            </Box>
                            <Typography
                                sx={{
                                    color: '#1e293b',
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    opacity: 0.8
                                }}
                            >
                                {row.original.phone}
                            </Typography>
                        </Box>
                    </Box>
                )
            },
            {
                id: 'owner',
                header: () => (
                    <Tooltip title="Sort by Owner" arrow placement="top">
                        <span>OWNER</span>
                    </Tooltip>
                ),
                accessorKey: 'ownerName',
                cell: ({ row }) => {
                    const isDifferentAgent = row.original.AgentName && row.original.AgentName !== (row.original.ownerName || 'Mukesh Kumar');
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: isDifferentAgent ? 2 : 0, py: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                <Box sx={{
                                    width: 32, height: 32, borderRadius: '50%', border: '1.5px solid #e2e8f0',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    color: '#64748b', flexShrink: 0, backgroundColor: '#f8fafc'
                                }}>
                                    <UserIcon size={16} strokeWidth={2.5} />
                                </Box>
                                <Typography sx={{ fontSize: '14.5px', fontWeight: 600, color: '#333155 !important' }}>{row.original.ownerName || 'Mukesh Kumar'}</Typography>
                            </Box>
                            {isDifferentAgent && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                    <Box sx={{
                                        width: 32, height: 32, borderRadius: '50%', border: '1.5px solid #e2e8f0',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        color: '#64748b', flexShrink: 0, backgroundColor: '#f8fafc'
                                    }}>
                                        <UserIcon size={16} strokeWidth={2} />
                                    </Box>
                                    <Typography sx={{ fontSize: '12.5px', color: '#64748b', fontWeight: 600 }}>{row.original.AgentName}</Typography>
                                </Box>
                            )}
                        </Box>
                    );
                }
            },
            {
                id: 'action',
                header: 'ACTION',
                cell: (info) => {
                    const row = info.row.original;
                    const statusLabel = getStatusDescriptor(
                        row.taskStatus, row.endDate, row.completedDate,
                        row.taskTitle, row.startDate, row.taskStatus,
                        row.outcomeName, row.createdDate
                    );
                    const isCompleted = statusLabel.toLowerCase().startsWith('completed');

                    const checkRowPerm = (permFlag) => {
                        const val = row[permFlag];
                        if (val === undefined || val === null) return true;
                        return val !== false && String(val).toLowerCase() !== 'false';
                    };

                    const settingActions = [];
                    if (checkRowPerm('hasView')) {
                        settingActions.push({ text: 'View', icon: <Icon icon="tabler:eye" fontSize={20} style={{ color: '#3b82f6' }} />, menuItemProps: { onClick: () => { setSelectedAppointment(row); setDetailMode('view'); setIsDetailOpen(true); } } });
                    }

                    if (!isCompleted) {
                        if (crmOperationPerms?.Edit) {
                            settingActions.push({ text: 'Edit', icon: <Icon icon="tabler:edit" fontSize={20} style={{ color: '#6366f1' }} />, menuItemProps: { onClick: () => { setAppointmentToEdit(row); setShowAddAppointmentModal(true); } } });
                        }
                        if (crmOperationPerms?.Edit && checkRowPerm('hasCompletion')) {
                            settingActions.push({ text: 'Mark as Completed', icon: <Icon icon="tabler:circle-check" fontSize={20} style={{ color: '#10b981' }} />, menuItemProps: { onClick: () => handleMarkAsCompletedClick(row) } });
                        }
                        if (crmOperationPerms?.Edit && checkRowPerm('hasComment')) {
                            settingActions.push({ text: 'Add Comment', icon: <Icon icon="tabler:message-2" fontSize={20} style={{ color: '#f59e0b' }} />, menuItemProps: { onClick: () => handleCommentClick(row) } });
                        }
                    }

                    if (!isCompleted && crmOperationPerms?.Delete) {
                        settingActions.push({ text: 'Remove', icon: <Icon icon="tabler:trash" fontSize={20} style={{ color: '#ef4444' }} />, menuItemProps: { onClick: () => handleRemoveTask(row.id || row.TaskHistoryId || row.Id) } });
                    }

                    const filteredSettings = settingActions;

                    const allCrmActions = [
                        { id: 'followup', text: 'Add Followup', icon: <Icon icon="ri:user-follow-line" fontSize={20} style={{ color: '#22c55e' }} />, menuItemProps: { onClick: () => handleRowAction(row, 'followup') } },
                        { id: 'send-mail', text: 'Send Mail', icon: <Icon icon="ri:mail-send-line" fontSize={20} style={{ color: '#ef4444' }} />, menuItemProps: { onClick: () => handleRowAction(row, 'mail') } },
                        { id: 'send-sms', text: 'Send SMS', icon: <Icon icon="ri:chat-3-line" fontSize={20} style={{ color: '#3b82f6' }} />, menuItemProps: { onClick: () => handleRowAction(row, 'sms') } },
                        { id: 'send-voice', text: 'Send Voice', icon: <Icon icon="ri:mic-line" fontSize={20} style={{ color: '#a855f7' }} />, menuItemProps: { onClick: () => handleRowAction(row, 'voice') } },
                        { id: 'add-notes', text: 'Add Note', icon: <Icon icon="ri:sticky-note-line" fontSize={20} style={{ color: '#f59e0b' }} />, menuItemProps: { onClick: () => handleRowAction(row, 'notes') } },
                        { id: 'upload-document', text: 'Upload Document', icon: <Icon icon="ri:upload-cloud-2-line" fontSize={20} style={{ color: '#06b6d4' }} />, menuItemProps: { onClick: () => handleRowAction(row, 'upload') } },
                        { id: 'addtask', text: 'Add Task', icon: <Icon icon="ri:checkbox-line" fontSize={20} style={{ color: '#3f51b5' }} />, menuItemProps: { onClick: () => handleRowAction(row, 'addtask') } },
                        { id: 'addappointment', text: 'Add Appointment', icon: <Icon icon="ri:calendar-event-line" fontSize={20} style={{ color: '#ec4899' }} />, menuItemProps: { onClick: () => handleRowAction(row, 'addappointment') } },
                        { id: 'adddeal', text: 'Add Deal', icon: <Icon icon="ri:hand-coin-line" fontSize={20} style={{ color: '#10b981' }} />, menuItemProps: { onClick: () => handleRowAction(row, 'adddeal') } },
                        { id: 'fill-webform', text: 'Fill Webform', icon: <Icon icon="ri:file-list-3-line" fontSize={20} style={{ color: '#64748b' }} />, menuItemProps: { onClick: () => handleRowAction(row, 'fillWebform') } }
                    ];

                    const crmActions = allCrmActions.filter(action => {
                        if (!crmOperationPerms) return true;
                        switch (action.id) {
                            case 'followup': return crmOperationPerms.AddFollowup !== false;
                            case 'send-mail': return crmOperationPerms.SendMail !== false;
                            case 'send-sms': return crmOperationPerms.SendSms !== false;
                            case 'send-voice': return crmOperationPerms.SendVoice !== false;
                            case 'add-notes': return crmOperationPerms.AddNote !== false;
                            case 'upload-document': return crmOperationPerms.UploadDocument !== false;
                            case 'addtask': return crmOperationPerms.AddTask !== false;
                            case 'addappointment': return crmOperationPerms.AddAppointment !== false;
                            case 'adddeal': return crmOperationPerms.AddDeal !== false;
                            case 'fill-webform': return crmOperationPerms.AddWebform !== false;
                            default: return true;
                        }
                    });

                    return (
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, width: '100%', minWidth: 100 }} onClick={(e) => e.stopPropagation()}>
                            <OptionMenu
                                icon={<Icon icon="ri:more-2-fill" fontSize={20} />}
                                iconButtonProps={{
                                    sx: {
                                        border: '1px solid #e2e8f0',
                                        borderRadius: '8px',
                                        padding: '6px',
                                        backgroundColor: '#fff',
                                        color: '#64748b',
                                        transition: 'all 0.2s',
                                        '&:hover': {
                                            backgroundColor: '#f8fafc',
                                            borderColor: '#666cff',
                                            color: '#666cff',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                        }
                                    }
                                }}
                                options={filteredSettings}
                            />
                            <OptionMenu
                                icon={<Icon icon="ri:settings-4-line" fontSize={20} />}
                                iconButtonProps={{
                                    sx: {
                                        border: '1px solid #e2e8f0',
                                        borderRadius: '8px',
                                        padding: '7px',
                                        backgroundColor: '#fff',
                                        color: '#64748b',
                                        transition: 'all 0.2s',
                                        '&:hover': {
                                            backgroundColor: '#f8fafc',
                                            borderColor: '#666cff',
                                            color: '#666cff',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                        }
                                    }
                                }}
                                options={crmActions}
                            />
                        </Box>
                    );
                },
                enableSorting: false
            }
        ];
        const filteredColumns = cols.filter(col => {
            if (col.id === 'title') return !isHiddenField('Subject');
            if (col.id === 'date') return !isHiddenField('StartDate') && !isHiddenField('DueDate');
            if (col.id === 'relatedTo') return !isHiddenField('PersonName');
            if (col.id === 'owner') return !isHiddenField('Owner');
            return true;
        });

        return hasMassPerms ? filteredColumns : filteredColumns.filter(c => c.id !== 'select');
    }, [
        handleRowSelectionChange,
        handleRemoveTask,
        handleMarkAsCompletedClick,
        handleRowAction,
        handleCommentClick,
        crmOperationPerms,
        hasMassPerms,
        isHiddenField
    ]);

    const handleCustomSearchSubmit = useCallback((id) => {
        setCustomSearchId(id);
        setCurrentPage(1);
    }, []);

    const handleCustomSearchClear = useCallback(() => {
        setCustomSearchId(0);
        setCurrentPage(1);
    }, []);

    // Data Fetching
    const fetchTasks = async (isCancelled = false) => {
        setLoading(true);
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const finalFilter = buildFilterText();
            const res = await fetch(GET_APPOINTMENT_LIST, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: "-2295521862261168",
                    Details: {
                        FilterText: finalFilter || "",
                        UserId: parseInt(uid),
                        Mode: "A",
                        OffsetValue: 0,
                        PagingSize: 3000,
                        CriteriaName: ""
                    }
                })
            });
            const raw = await res.json();

            if (isCancelled) return;

            let dataArray = [];
            let tRecords = 0;
            if (raw && raw.Details && Array.isArray(raw.Details)) {
                dataArray = raw.Details;
                tRecords = dataArray.length > 0 ? (dataArray[0].TotalRow || dataArray.length) : 0;
            } else if (raw && raw.Details && raw.Details.data) {
                dataArray = raw.Details.data;
                tRecords = raw.Details.totalRecords || raw.Details.TotalCount || 0;
            } else if (raw && raw.data) {
                dataArray = raw.data;
                tRecords = raw.recordsFiltered || raw.recordsTotal || 0;
            } else if (Array.isArray(raw)) {
                dataArray = raw;
                tRecords = raw.length;
            }

            const mapped = dataArray.map(item => {
                const sanitize = (val) => String(val || '').replace(/,+/g, '').trim();
                const isValid = (val) => val && val !== '0' && val.toLowerCase() !== 'unknown' && val !== '-';

                let bestName = "-";
                // Prioritizing PersonName then RelatedTo (which usually contains the name in the new API)
                const pName = sanitize(item.PersonName || item.RelatedTo);
                const pMobile = sanitize(item.CsvMobileNo || item.MobileNo || item.Phone || item.Mobile);
                const pEmail = sanitize(item.CsvEmailId || item.EmailId);

                if (isValid(pName)) {
                    bestName = pName;
                } else if (isValid(pMobile)) {
                    bestName = pMobile;
                } else if (isValid(pEmail)) {
                    bestName = pEmail;
                }

                const displayPhone = isValid(pMobile) ? pMobile : (item.Phone || item.Mobile || item.MobileNo || '');

                return {
                    ...item,
                    // Ensuring ID parity for actions (View/Edit/Remove)
                    id: item.TaskHistoryId || item.TaskId || item.id || item.Id,
                    taskTitle: (item.Title || item.TaskTitle || '').replace(/#\d+\s*/g, '').trim(),
                    leadId: item.LeadId || item.EnquiryId || item.LeadNo,
                    name: bestName,
                    phone: displayPhone,
                    startDate: item.StartDate || item.Date || item.CreatedDate || '',
                    endDate: item.EndDate || item.DueDate || item.StartDate || '',
                    startTime: item.StartTime || item.Time || '',
                    endTime: item.EndTime || '',
                    completedDate: item.CompletedOn || item.CompletedDate || item.ModifiedOn || '',
                    createdDate: item.CreatedOn || item.CreatedDate || '',
                    taskStatus: item.TaskStatus || item.Status || 'Open',
                    outcomeName: item.OutcomeName || item.Outcome || '',
                    avatar: item.RelatedToProfile || '',
                    threshold: item.FollowUpCount || item.FollowupCount || item.FollowUpDateCount || item.Threshold || item.ThresholdColor || 0,
                    ownerName: item.OwnerName || item.AgentName || item.CreatorName || 'Mukesh Kumar',
                    _statusLower: (item.TaskStatus || item.Status || 'Open').toLowerCase()
                };
            });
            setTasks(mapped);
            setTotalRecords(tRecords || mapped.length);

            // Fetch global stats on initial load
            if (isInitialLoad) {
                fetchInitialCounts(false);
            }

            // Update global stats only on initial "All" fetch to maintain dashboard card counts
            if (appointmentStatusFilter.includes('All') && !searchTerm && !advancedFilters) {
                const newStats = {
                    total: tRecords || mapped.length,
                    completed: mapped.filter(t => t._statusLower.startsWith('completed')).length, // This is still limited to one page
                    overdue: mapped.filter(t => t._statusLower === 'over due').length,
                    open: mapped.filter(t => t._statusLower === 'open').length
                };
                // Note: True global counts for statuses require a dedicated stats API. 
                // For now, we use what's visible or the total records.
                // Global counts are handled by fetchInitialCounts
                // setGlobalStats(prev => ({ ...prev, total: raw.recordsTotal || mapped.length }));
            }
        } catch (e) {
            console.error("[AppointmentModule] fetchTasks error:", e);
        } finally {
            if (!isCancelled) {
                setLoading(false);
                setIsInitialLoad(false);
            }
        }
    };

    const initialCountsFetchedRef = useRef(false);

    const fetchInitialCounts = async (force = false) => {
        if (!force && initialCountsFetchedRef.current) return;
        initialCountsFetchedRef.current = true;
        try {
            const uid = localStorage.getItem('userId') || '34594';

            const payload = {
                Token: "-2295521862261168",
                Details: {
                    Mode: "GetCounterForPages",
                    Details: {
                        PageName: "Task",
                        UserId: parseInt(uid),
                        Mode: "A",
                        FilterText: "",
                        CriteriaName: ""
                    }
                }
            };

            const reqOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify(payload)
            };

            const STATS_API_URL = `${NEWV3_BASE_URL}${API_ENDPOINTS.COMMON.HELP_DATA_BIND}`;
            const res = await fetch(STATS_API_URL, reqOptions);
            const data = await (res.ok ? res.json() : {});

            if (data && data.Details && data.Details.length > 0) {
                const stats = data.Details[0];
                setGlobalStats({
                    total: stats.TotalCount || 0,
                    completed: stats.CompletedCount || 0,
                    overdue: stats.OverdueCount || 0,
                    open: stats.OpenCount || 0
                });
            }
        } catch (e) {
            console.error("[AppointmentModule] fetchInitialCounts error:", e);
        }
    };

    useEffect(() => {
        let isCancelled = false;
        fetchTasks(isCancelled);
        return () => { isCancelled = true; };
    }, [dashboardFilter, customSearchId, appointmentStatusFilter]);

    // Reset page on search
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    // Reset to first page when search or filters change - but don't re-trigger fetchTasks manually here
    // as the currentPage dependency in the main effect will handle it.
    useEffect(() => {
        if (currentPage !== 1) {
            setCurrentPage(1);
        }
    }, [searchTerm, appointmentStatusFilter, advancedFilters]);

    const stats = useMemo(() => {
        const counts = {
            total: globalStats.total || 0,
            overdue: globalStats.overdue || 0,
            open: globalStats.open || 0,
            completed: globalStats.completed || 0
        };

        return counts;
    }, [globalStats]);

    const clearDashboardFilter = () => {
        if (location.search) {
            navigate('/appointments', { replace: true, state: {} });
        }
    };

    const handleStatusFilterChange = (status) => {
        if (status === 'ResetAll' || status === 'All') {
            setAppointmentStatusFilter(['All']);
            setDashboardFilter('');
            setSearchTerm('');
            setAdvancedFilters(null);
            setCustomSearchId(0);
            setCurrentPage(1);
            return;
        }

        // Single selection for server-side filtering as requested
        setAppointmentStatusFilter([status]);
        setCurrentPage(1);
    };

    const strictlyFilteredTasks = useMemo(() => {
        let result = tasks;

        // 1. Search Filter (Word-based AND logic)
        if (searchTerm) {
            const searchWords = searchTerm.toLowerCase().trim().split(/\s+/).filter(word => word.length > 0);
            if (searchWords.length > 0) {
                result = result.filter(appt => {
                    const searchableValues = [
                        appt.name,
                        appt.PersonName,
                        appt.LeadName,
                        appt.RelatedTo,
                        appt.taskTitle,
                        appt.Title,
                        appt.TaskTitle,
                        appt.description,
                        appt.ownerName,
                        appt.AgentName,
                        appt.phone,
                        appt.leadId,
                        appt.outcomeName
                    ].filter(Boolean).map(val => String(val).toLowerCase()).join(' ');

                    return searchWords.every(word => searchableValues.includes(word));
                });
            }
        }

        // 2. Advanced Filters (Rule Based)
        if (advancedFilters && advancedFilters.rows && Array.isArray(advancedFilters.rows) && advancedFilters.rows.length > 0) {
            const { logic, rows } = advancedFilters;
            result = result.filter(appt => {
                const rowMatches = rows.map(row => {
                    const searchVal = String(row.value || '').toLowerCase().trim();
                    if (!searchVal) return true;

                    let valuesToCheck = [];
                    const primaryVal = appt[row.field];
                    if (primaryVal !== undefined && primaryVal !== null) {
                        valuesToCheck.push(String(primaryVal).toLowerCase().trim());
                    }

                    // Fallbacks for common field names in Appointment
                    if (row.field === 'name' || row.field === 'LeadName' || row.field === 'PersonName') {
                        if (appt.name) valuesToCheck.push(String(appt.name).toLowerCase().trim());
                    } else if (row.field === 'taskTitle' || row.field === 'Title' || row.field === 'Subject') {
                        if (appt.taskTitle) valuesToCheck.push(String(appt.taskTitle).toLowerCase().trim());
                    } else if (row.field === 'ownerName' || row.field === 'AgentName') {
                        if (appt.ownerName) valuesToCheck.push(String(appt.ownerName).toLowerCase().trim());
                        if (appt.AgentName) valuesToCheck.push(String(appt.AgentName).toLowerCase().trim());
                    } else if (row.field === 'statusLabel' || row.field === 'Status') {
                        const statusLabel = getStatusDescriptor(
                            appt.taskStatus, appt.endDate, appt.completedDate,
                            appt.taskTitle, appt.startDate, appt.taskStatus,
                            appt.outcomeName, appt.createdDate
                        );
                        valuesToCheck.push(statusLabel.toLowerCase().trim());
                    }

                    const fieldMeta = appointmentFields.find(f => f.value === row.field);
                    const isDateField = fieldMeta?.type === 'date' || row.field === 'startDate' || row.field === 'createdDate';

                    return valuesToCheck.some(val => {
                        if (isDateField) {
                            const apptDate = parseCustomDate(val);
                            const filterDate = new Date(row.value);
                            if (!apptDate || isNaN(filterDate.getTime())) return false;

                            const tY = apptDate.getFullYear();
                            const tM = apptDate.getMonth();
                            const tD = apptDate.getDate();
                            const fY = filterDate.getFullYear();
                            const fM = filterDate.getMonth();
                            const fD = filterDate.getDate();

                            switch (row.operator) {
                                case 'equals': return tY === fY && tM === fM && tD === fD;
                                case 'not_equal': return !(tY === fY && tM === fM && tD === fD);
                                default: return tY === fY && tM === fM && tD === fD;
                            }
                        }

                        switch (row.operator) {
                            case 'equals': return val === searchVal;
                            case 'not_equal': return val !== searchVal;
                            case 'starts_with': return val.startsWith(searchVal);
                            case 'ends_with': return val.endsWith(searchVal);
                            case 'contains': return val.includes(searchVal);
                            case 'not_contains': return !val.includes(searchVal);
                            default: return val.includes(searchVal);
                        }
                    });
                });

                return logic === 'ALL' ? rowMatches.every(m => m) : rowMatches.some(m => m);
            });
        }

        // 3. Sorting
        if (advancedFilters && advancedFilters.sortBy) {
            result = [...result].sort((a, b) => {
                const sortBy = advancedFilters.sortBy;
                if (sortBy === 'created_desc') {
                    return (parseCustomDate(b.createdDate)?.getTime() || 0) - (parseCustomDate(a.createdDate)?.getTime() || 0);
                }
                if (sortBy === 'created_asc') {
                    return (parseCustomDate(a.createdDate)?.getTime() || 0) - (parseCustomDate(b.createdDate)?.getTime() || 0);
                }
                if (sortBy === 'modified_desc') {
                    const aMod = a.modifiedon || a.ModifiedOn || a.completedDate || a.createdDate;
                    const bMod = b.modifiedon || b.ModifiedOn || b.completedDate || b.createdDate;
                    return (parseCustomDate(bMod)?.getTime() || 0) - (parseCustomDate(aMod)?.getTime() || 0);
                }
                if (sortBy === 'modified_asc') {
                    const aMod = a.modifiedon || a.ModifiedOn || a.completedDate || a.createdDate;
                    const bMod = b.modifiedon || b.ModifiedOn || b.completedDate || b.createdDate;
                    return (parseCustomDate(aMod)?.getTime() || 0) - (parseCustomDate(bMod)?.getTime() || 0);
                }
                if (sortBy === 'date_desc') {
                    return (parseCustomDate(b.startDate)?.getTime() || 0) - (parseCustomDate(a.startDate)?.getTime() || 0);
                }
                if (sortBy === 'date_asc') {
                    return (parseCustomDate(a.startDate)?.getTime() || 0) - (parseCustomDate(b.startDate)?.getTime() || 0);
                }
                return 0;
            });
        }
        // No default local sort: keep the order exactly as received from the API response

        // 4. Deduplicate by unique id or title+date to prevent duplicates in UI
        const seen = new Set();
        result = result.filter(appt => {
            const key = appt.id || `${appt.taskTitle}-${appt.startDate}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });

        return result;
    }, [tasks, searchTerm, appointmentStatusFilter, advancedFilters]);

    const currentViewData = useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        return strictlyFilteredTasks.slice(start, start + itemsPerPage);
    }, [strictlyFilteredTasks, currentPage, itemsPerPage]);

    // Reset selection on search to ensure details panel refreshes with the top result
    useEffect(() => {
        if (searchTerm) {
            setSelectedAppointment(null);
        }
    }, [searchTerm]);

    // Auto-select first appointment in grid view and handle empty state
    useEffect(() => {
        if (viewMode === 'grid') {
            if (currentViewData.length === 0) {
                setSelectedAppointment(null);
            } else {
                // If nothing is selected OR the selected appointment is no longer in the current view data
                const isSelectedInView = selectedAppointment && currentViewData.some(appt => appt.id === selectedAppointment.id);
                if (!selectedAppointment || !isSelectedInView) {
                    setSelectedAppointment(currentViewData[0]);
                }
            }
        }
    }, [viewMode, currentViewData]);

    const totalPages = Math.ceil(strictlyFilteredTasks.length / itemsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const getAppointmentCompletionBadge = (appt) => {
        const sl = getStatusDescriptor(
            appt.taskStatus,
            appt.endDate,
            appt.completedDate,
            appt.taskTitle,
            appt.startDate,
            appt.taskStatus,
            appt.outcomeName,
            appt.createdDate
        );
        const isCom = sl.startsWith('Completed');
        const isOvd = sl.startsWith('Overdue');
        const isDue = sl === 'Due Today';

        const bg = isCom ? '#28c76f' : isOvd ? '#ea5455' : isDue ? '#ff9f43' : '#3b82f6';

        return (
            <span style={{
                display: 'inline-block',
                backgroundColor: bg,
                color: '#fff',
                padding: '2px 10px',
                borderRadius: '6px',
                fontSize: '11px',
                fontWeight: 700,
                textTransform: 'none',
                whiteSpace: 'nowrap'
            }}>
                {sl}
            </span>
        );
    };

    const handleCalendarEventClick = (event) => {
        const appt = tasks.find(t =>
            t.id?.toString() === event.id?.toString() ||
            (t.TaskHistoryId && t.TaskHistoryId?.toString() === event.id?.toString())
        );
        if (appt) {
            setSelectedAppointment(appt);
            setIsDetailOpen(true);
            setDetailMode('view');
        } else if (event) {
            setSelectedAppointment(event);
            setIsDetailOpen(true);
            setDetailMode('view');
        }
    };

    const massPanel = Object.keys(rowSelection).length > 0 ? (
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
            <MassOperationPanel
                selectedCount={selectedCount}
                totalCount={totalRecords}
                variant="header"
                onClose={() => {
                    setRowSelection({});
                    setIsAllSelectedAcrossPages(false);
                    setAllIds([]);
                }}
                onGo={handleMassAction}
            />
            {isAllSelectedAcrossPages && (
                <Box sx={{ ml: 4, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography sx={{ fontSize: '13px', color: '#64748b' }}>
                        All {totalRecords} appointments are selected.
                    </Typography>
                    <Button
                        size="small"
                        onClick={() => {
                            setRowSelection({});
                            setIsAllSelectedAcrossPages(false);
                            setAllIds([]);
                        }}
                        sx={{
                            textTransform: 'none',
                            fontSize: '13px',
                            fontWeight: 600,
                            color: '#00897b',
                            '&:hover': { backgroundColor: 'rgba(0, 137, 123, 0.08)' }
                        }}
                    >
                        Clear selection
                    </Button>
                </Box>
            )}
        </div>
    ) : null;

    const customHeaderActions = (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <AppointmentFilterationActions
                viewMode={viewMode}
                onAdd={crmOperationPerms?.Add ? () => { setAppointmentToEdit(null); setShowAddAppointmentModal(true); } : null}
                onFilterChange={(filters) => {
                    // Filter change handling
                }}
                onExport={crmOperationPerms?.Export ? handleExportToCSV : null}
                onCustomDownload={crmOperationPerms?.Export ? () => setIsCustomDownloadOpen(true) : null}
                isOpen={isFilterOpen}
                setIsOpen={setIsFilterOpen}
            />
        </div>
    );

    if (crmOperationPerms && crmOperationPerms.View === false) {
        return (
            <div className="appointment-module-root" style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8fafc' }}>
                <div style={{ background: 'white', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', textAlign: 'center', maxWidth: '400px' }}>
                    <div style={{ width: '64px', height: '64px', background: '#fee2e2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
                        <X size={32} color="#ef4444" />
                    </div>
                    <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1e293b', marginBottom: '16px' }}>Access Denied</h2>
                    <p style={{ color: '#64748b', marginBottom: '32px', lineHeight: '1.5' }}>
                        You do not have permission to view the Appointment Module. Please contact your administrator if you believe this is a mistake.
                    </p>
                    <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
                        <button
                            onClick={() => navigate('/dashboard')}
                            style={{ padding: '10px 20px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '500' }}
                        >
                            Dashboard
                        </button>
                        <button
                            onClick={() => { localStorage.clear(); navigate('/'); }}
                            style={{ padding: '10px 20px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '500' }}
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Box sx={{ backgroundColor: '#f8f9fa', height: 'calc(100vh - 64px)', width: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <Box className="module-content-wrapper" sx={{ flex: 1, overflowY: 'auto', minHeight: 0, display: 'flex', flexDirection: 'column', width: '100%' }}>
                <SubHeader
                    pageName="Appointments"
                    pageCode="PAG10035"
                    title="Appointment "
                    totalCount={(searchTerm || (advancedFilters?.rows?.length > 0) || dashboardFilter) ? strictlyFilteredTasks.length : totalRecords}
                    filterCount={advancedFilters?.rows?.length || 0}
                    searchQuery={searchTerm}
                    setSearchQuery={setSearchTerm}
                    searchPlaceholder="Search appointments..."
                    viewMode={viewMode}
                    setViewMode={setViewMode}
                    onAddClick={crmOperationPerms?.Add ? () => { setAppointmentToEdit(null); setShowAddAppointmentModal(true); } : null}
                    showViewSwitcher={true}
                    showGrid={true}
                    showTable={true}
                    massActionPanel={selectedCount > 0 ? massPanel : null}
                    showSettings={true}
                    showExport={!!crmOperationPerms?.Export}
                    onExportClick={crmOperationPerms?.Export ? handleExportToCSV : null}
                    showCustomExport={!!crmOperationPerms?.Export}
                    onCustomExportClick={crmOperationPerms?.Export ? () => setIsCustomDownloadOpen(true) : null}
                    showSearch={!!crmOperationPerms?.Search}
                    showAdvanceFilter={!!crmOperationPerms?.Search}
                    showCustomSearch={!!crmOperationPerms?.Search}
                    onCustomSearchSubmit={crmOperationPerms?.Search ? (id) => { setCustomSearchId(id); setCurrentPage(1); } : null}
                    onCustomSearchClear={() => { setCustomSearchId(0); setCurrentPage(1); }}
                    advanceFilterFields={appointmentFields}
                    onAdvanceFilterSubmit={crmOperationPerms?.Search ? handleAdvancedFilterSubmit : null}
                />



                {(viewMode === 'table' || viewMode === 'grid') && (
                    <div
                        className="stats-cards-row"
                        style={{
                            width: '100%',
                            marginBottom: '0px',
                            background: '#fff',
                            position: 'relative',
                            zIndex: 900, // Higher than Content Layout but lower than SubHeader/Menus
                            overflow: 'visible'
                        }}
                    >
                        <PremiumModuleCards
                            stats={stats}
                            onStatusClick={handleStatusFilterChange}
                            moduleName="Appointment"
                            activeFilters={appointmentStatusFilter}
                        />
                    </div>
                )}

                {/* Dashboard filter indicator */}
                {!viewingLeadId && location.search && location.state?.filterLabel && (
                    <div style={{ padding: '8px 24px', background: '#eff6ff', borderBottom: '1px solid #bfdbfe' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '600', color: '#1e40af' }}>
                            <Filter size={14} />
                            <span>Filtered by Dashboard: {location.state.filterLabel}</span>
                            <button
                                onClick={clearDashboardFilter}
                                className="clear-filter-circle"
                                style={{
                                    background: '#dbeafe', border: 'none', borderRadius: '50%',
                                    width: '20px', height: '20px', display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', cursor: 'pointer', color: '#1e3a8a', padding: 0, marginLeft: '4px'
                                }}
                            >
                                <Plus size={14} style={{ transform: 'rotate(45deg)' }} />
                            </button>
                        </div>
                    </div>
                )}

                {/* View Module Content */}
                <div className="content-layout" style={{ display: 'flex', flex: 1, overflow: 'hidden', position: 'relative' }}>
                    {viewingLeadId ? (
                        <Box sx={{ flex: 1, height: '100%', overflow: 'hidden' }}>
                            <CommonLeadDetails leadId={viewingLeadId} onBack={() => setViewingLeadId(null)} module="appointment" maskObject={maskObject} isHiddenField={isHiddenField} />
                        </Box>
                    ) : (
                        <>
                            {/* Unified Loader for both initial load and filtered updates */}
                            {loading && (
                                <Box sx={{
                                    position: 'absolute',
                                    top: 0, left: 0, right: 0, bottom: 0,
                                    zIndex: 2000,
                                    // On initial load, solid white background. On updates, semi-transparent.
                                    bgcolor: (tasks.length === 0 || isInitialLoad) ? '#fff' : 'rgba(255, 255, 255, 0.5)',
                                    backdropFilter: 'blur(2px)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'background-color 0.3s ease'
                                }}>
                                    <Loader message={(tasks.length === 0 || isInitialLoad) ? "Loading appointments..." : "Applying Filters..."} />
                                </Box>
                            )}

                            <>
                                {viewMode === 'grid' && (
                                    <GridMainPanelLayout
                                        type="appointment"
                                        data={currentViewData.map(a => maskObject(a))}
                                        totalRecords={strictlyFilteredTasks.length}
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        onPageChange={handlePageChange}
                                        selectedItem={selectedAppointment}
                                        onSelectItem={setSelectedAppointment}
                                        rowSelection={rowSelection}
                                        onRowSelectionChange={handleRowSelectionChange}
                                        onViewLead={setViewingLeadId}
                                        getCompletionBadge={getAppointmentCompletionBadge}
                                        formatDate={formatDateDisplay}
                                        getInitials={getInitials}
                                        hideSelection={!hasMassPerms}
                                    />
                                )}
                                {viewMode === 'table' && (
                                    <Box sx={{ flex: 1, overflow: 'hidden', height: '100%', display: 'flex', flexDirection: 'column', p: 0 }}>
                                        <PremiumModuleTable
                                            columns={columns}
                                            data={currentViewData.map(a => maskObject(a))}
                                            totalRecords={strictlyFilteredTasks.length}
                                            currentPage={currentPage}
                                            itemsPerPage={itemsPerPage}
                                            onPageChange={(page) => setCurrentPage(page)}
                                            onGlobalFilterChange={setSearchTerm}
                                            onRowSelectionChange={handleRowSelectionChange}
                                            rowSelection={rowSelection}
                                            onManualRowSelectionChange={handleRowSelectionChange}
                                            globalFilter={searchTerm}
                                        />
                                    </Box>
                                )}
                                {viewMode === 'calendar' && (
                                    <div className="calendar-view-wrapper" style={{ flex: 1, overflow: 'auto', p: 0, position: 'relative' }}>
                                        <DynamicCalendar
                                            entityLabel="appointment"
                                            headerLegend={
                                                <Stack direction="row" spacing={2.5} sx={{ mt: 1.5, flexWrap: 'wrap', gap: '12px', px: 3 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#2563eb' }} />
                                                        <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#475569' }}>Open</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#f97316' }} />
                                                        <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#475569' }}>Upcoming</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#ef4444' }} />
                                                        <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#475569' }}>Overdue</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#10b981' }} />
                                                        <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#475569' }}>Completed</Typography>
                                                    </Box>
                                                </Stack>
                                            }
                                            events={strictlyFilteredTasks.map(t => ({
                                                ...t,
                                                id: t.id,
                                                title: t.taskTitle,
                                                date: parseCustomDate(t.startDate) || new Date(),
                                                status: t.taskStatus,
                                                name: t.name,
                                                enquiryId: t.leadId,
                                                ownerName: t.ownerName
                                            }))}
                                            eventRenderer={renderCalendarEvent}
                                            onEventClick={handleCalendarEventClick}
                                            onDateChange={(date, view) => setCalendarView(view)}
                                            initialView="month"
                                            initialDate={new Date()}
                                        />
                                    </div>
                                )}
                            </>
                        </>
                    )}
                </div>
            </Box>

            {/* Unified Mass Operation Drawer */}
            <MassOperationDrawer
                isOpen={showMassDrawer}
                onClose={() => setShowMassDrawer(false)}
                operationMode={activeOperationMode}
                selectedCount={selectedCount}
            />

            {/* Mass Update Panel (Task Module Parity) */}
            <Panels
                isOpen={showMassUpdatePanel}
                onClose={() => { setShowMassUpdatePanel(false); resetMassUpdateForm(); }}
                backTitle="Appointment"
                title="Appointment"
                width="50%"
            >
                <div className="drawer-body">
                    <h3 style={{ margin: '0 0 20px 0', fontSize: '18px', color: '#333' }}>Mass Update</h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <div>
                            <label style={{ display: 'block', fontSize: '13px', color: '#555', marginBottom: '6px' }}>Description</label>
                            <textarea rows="3" value={massUpdateData.Description} onChange={e => setMassUpdateData(prev => ({ ...prev, Description: e.target.value }))} style={{ width: '100%', padding: '8px 12px', border: '1px solid #ced4da', borderRadius: '4px' }} placeholder="Enter Description" />
                        </div>
                        <div>
                            <label style={{ display: 'block', fontSize: '13px', color: '#555', marginBottom: '6px' }}>Remarks</label>
                            <textarea rows="3" value={massUpdateData.Remarks} onChange={e => setMassUpdateData(prev => ({ ...prev, Remarks: e.target.value }))} style={{ width: '100%', padding: '8px 12px', border: '1px solid #ced4da', borderRadius: '4px' }} placeholder="Enter Remarks" />
                        </div>
                        <div style={{ display: 'flex', gap: '12px' }}>
                            <div style={{ flex: 1 }}>
                                <label style={{ display: 'block', fontSize: '13px', color: '#555', marginBottom: '6px' }}>Start Date</label>
                                <div className="premium-datetime-container" onClick={(e) => e.currentTarget.querySelector('input').showPicker()}>
                                    <Calendar size={18} className="datetime-icon" />
                                    <div className="premium-datetime-value">
                                        {formatDateTimeDisplay(massUpdateData.StartDate)}
                                    </div>
                                    <input
                                        type="datetime-local"
                                        value={massUpdateData.StartDate}
                                        min={getLocalISO()}
                                        onChange={(e) => setMassUpdateData(prev => ({ ...prev, StartDate: e.target.value }))}
                                        className="hidden-datetime-input"
                                    />
                                </div>
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={{ display: 'block', fontSize: '13px', color: '#555', marginBottom: '6px' }}>End Date</label>
                                <div className="premium-datetime-container" onClick={(e) => e.currentTarget.querySelector('input').showPicker()}>
                                    <Calendar size={18} className="datetime-icon" />
                                    <div className="premium-datetime-value">
                                        {formatDateTimeDisplay(massUpdateData.EndDate)}
                                    </div>
                                    <input
                                        type="datetime-local"
                                        value={massUpdateData.EndDate}
                                        min={getLocalISO()}
                                        onChange={(e) => setMassUpdateData(prev => ({ ...prev, EndDate: e.target.value }))}
                                        className="hidden-datetime-input"
                                    />
                                </div>
                            </div>
                        </div>
                        <div>
                            <label style={{ display: 'block', fontSize: '13px', color: '#555', marginBottom: '6px' }}>Where</label>
                            <input ref={whereInputRef} type="text" value={massUpdateData.Where} onChange={e => setMassUpdateData(prev => ({ ...prev, Where: e.target.value }))} style={{ width: '100%', padding: '8px 12px', border: '1px solid #ced4da', borderRadius: '4px' }} placeholder="Where" />
                        </div>
                        <div>
                            <label style={{ display: 'block', fontSize: '13px', color: '#555', marginBottom: '6px' }}>Complete Address</label>
                            <textarea rows="2" value={massUpdateData.CompleteAddress} onChange={e => setMassUpdateData(prev => ({ ...prev, CompleteAddress: e.target.value }))} style={{ width: '100%', padding: '8px 12px', border: '1px solid #ced4da', borderRadius: '4px' }} placeholder="Address" />
                        </div>
                        <div>
                            <label style={{ display: 'block', fontSize: '13px', color: '#555', marginBottom: '6px' }}>Owner</label>
                            <select value={massUpdateData.Owner} onChange={e => setMassUpdateData(prev => ({ ...prev, Owner: e.target.value }))} style={{ width: '100%', padding: '8px 12px', border: '1px solid #ced4da', borderRadius: '4px' }}>
                                <option value="">Select Owner</option>
                                {massOwnerOptions.length > 0 && massOwnerOptions.map(o => <option key={o.Code} value={o.Code}>{o.Text}</option>)}
                            </select>
                        </div>
                        <div style={{ position: 'relative', marginTop: '20px' }} ref={massCollabRef}>
                            <label style={{ display: 'block', fontSize: '13px', color: '#555', marginBottom: '6px' }}>Collaborator</label>
                            <div onClick={(e) => { e.stopPropagation(); setMassCollabDropdownOpen(!massCollabDropdownOpen); }} style={{ padding: '8px 12px', border: '1px solid #ced4da', borderRadius: '4px', background: '#fff', minHeight: '38px', cursor: 'pointer', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                {massSelectedCollabs.length === 0 ? <span style={{ color: '#999' }}>Select Collaborators</span> : massSelectedCollabs.map(c => (<span key={c.id} style={{ background: '#e9ecef', padding: '2px 8px', borderRadius: '12px', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>{c.name}<span onClick={(e) => { e.stopPropagation(); setMassSelectedCollabs(prev => prev.filter(x => x.id !== c.id)); }} style={{ cursor: 'pointer', fontWeight: 'bold' }}>&times;</span></span>))}
                            </div>
                            {massCollabDropdownOpen && (
                                <Popper
                                    open={massCollabDropdownOpen}
                                    anchorEl={massCollabRef.current}
                                    placement="bottom-start"
                                    modifiers={[
                                        { name: 'flip', enabled: false },
                                        { name: 'preventOverflow', enabled: true, options: { boundary: 'viewport' } }
                                    ]}
                                    style={{ zIndex: 100001, width: massCollabRef.current?.offsetWidth }}
                                >
                                    <div
                                        style={{ background: '#fff', border: '1px solid #ddd', borderRadius: '4px', marginTop: '2px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div style={{ padding: '8px' }}>
                                            <input type="text" placeholder="Search..." value={massCollabSearch} onChange={e => setMassCollabSearch(e.target.value)} onClick={e => e.stopPropagation()} style={{ width: '100%', padding: '6px 8px', border: '1px solid #ddd', borderRadius: '4px' }} />
                                        </div>
                                        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                            {massCollabOptions.filter(o => o.Text.toLowerCase().includes(massCollabSearch.toLowerCase())).map(o => (
                                                <label key={o.Code} style={{ padding: '8px 12px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', margin: 0 }} onClick={(e) => e.stopPropagation()}>
                                                    <input
                                                        type="checkbox"
                                                        checked={massSelectedCollabs.some(c => String(c.id) === String(o.Code))}
                                                        onChange={() => {
                                                            const codeStr = String(o.Code);
                                                            if (massSelectedCollabs.some(c => String(c.id) === codeStr)) {
                                                                setMassSelectedCollabs(prev => prev.filter(c => String(c.id) !== codeStr));
                                                            } else {
                                                                setMassSelectedCollabs(prev => [...prev, { id: codeStr, name: o.Text }]);
                                                            }
                                                        }}
                                                        style={{ width: '16px', height: '16px' }}
                                                    />
                                                    <span style={{ fontSize: '13px' }}>{o.Text}</span>
                                                </label>))}
                                        </div>
                                    </div>
                                </Popper>
                            )}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' }}>
                            <input type="checkbox" checked={massUpdateData.MarkAsCompleted} onChange={e => setMassUpdateData(prev => ({ ...prev, MarkAsCompleted: e.target.checked }))} style={{ width: '16px', height: '16px' }} />
                            <label style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>Mark as completed</label>
                        </div>
                    </div>
                </div>
                <div className="drawer-footer" style={{ padding: '14px 24px', borderTop: '1px solid #ddd', display: 'flex', justifyContent: 'flex-end', background: '#f8f9fa' }}>
                    <button disabled={massSubmitting} onClick={async () => {
                        setMassSubmitting(true);
                        try {
                            const uid = localStorage.getItem('userId') || '34594';
                            const tokenId = localStorage.getItem('TokenId') || "-2295521862261168";
                            const collabIds = massSelectedCollabs.map(c => c.id).join(',');
                            const idsStr = isAllSelectedAcrossPages ? allIds.join(',') : Object.keys(rowSelection).filter(k => rowSelection[k]).join(',');

                            const formatDateForPayload = (dt) => {
                                if (!dt) return "";
                                return dt.replace('T', ' ') + ":00";
                            };

                            const payload = {
                                Token: tokenId || "-2295521862261168",
                                Details: {
                                    strUserID: uid,
                                    strParentID: uid,
                                    strTimezone: "Asia/Kolkata",
                                    massInsertUpdateTaskaAppointment: {
                                        LeadIds: "",
                                        Ids: idsStr,
                                        Title: "Mass Update",
                                        Description: massUpdateData.Description,
                                        Remarks: massUpdateData.Remarks,
                                        Address: massUpdateData.Where,
                                        StartDate: formatDateForPayload(massUpdateData.StartDate),
                                        EndDate: formatDateForPayload(massUpdateData.EndDate),
                                        AssignedTo: parseInt(massUpdateData.Owner || uid),
                                        IsActive: true,
                                        TaskId: 0,
                                        Status: massUpdateData.MarkAsCompleted ? "Completed" : "Pending",
                                        CreatedBy: parseInt(uid),
                                        OutcomesId: parseInt(massUpdateData.OutcomeId || "0"),
                                        CollabratoerUserIds: collabIds,
                                        IsSMS: false,
                                        IsEmail: false,
                                        IsTask: true,
                                        IsAppointment: false,
                                        TaskType: "",
                                        CompleteAddress: massUpdateData.CompleteAddress,
                                        Latitude: massUpdateData.Latitude || "",
                                        Longitude: massUpdateData.Longitude || "",
                                        SmsSchedule: "",
                                        EmailSchedule: "",
                                        NotifyMe: false,
                                        Batchid: 0,
                                        scheduledatetime: formatDateForPayload(massUpdateData.StartDate),
                                        emMessageId: "",
                                        emAttachmentId: "",
                                        DLTTemplateIDForSMSReminder: "",
                                        DLTTemplateIDForNotify: ""
                                    }
                                }
                            };

                            const response = await fetch(Mass_Update_API, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify(payload)
                            });

                            if (response.ok) {
                                setShowMassUpdatePanel(false);
                                setRowSelection({});
                                resetMassUpdateForm();
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Success',
                                    text: 'Appointment Updated Successfully',
                                    confirmButtonColor: '#3085d6'
                                }).then(() => {
                                    window.location.reload();
                                });
                            } else {
                                Swal.fire('Error', 'Mass update failed.', 'error');
                            }
                        } catch (e) {
                            console.error('Mass update error:', e);
                            Swal.fire('Error', 'An error occurred during mass update.', 'error');
                        } finally {
                            setMassSubmitting(false);
                        }
                    }} style={{ padding: '9px 28px', border: 'none', background: '#0d6efd', color: '#fff', borderRadius: '4px', cursor: 'pointer', fontWeight: '700', fontSize: '14px' }}>
                        {massSubmitting ? 'Updating...' : 'Update'}
                    </button>
                </div>
            </Panels>


            {/* Themed Toast Notification */}
            {toast && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(4px)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px', padding: '32px 48px', background: 'rgba(255,255,255,0.95)', borderRadius: '12px', boxShadow: '0 8px 32px rgba(0,0,0,0.1)' }}>
                        <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: toast.type === 'success' ? '#28a745' : '#dc3545', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '28px', color: '#fff', fontWeight: 'bold' }}>
                            {toast.type === 'success' ? '✓' : '✕'}
                        </div>
                        <p style={{ fontSize: '16px', fontWeight: '600', color: '#495057', margin: 0, textAlign: 'center' }}>{toast.message}</p>
                    </div>
                </div>
            )}



            <Panels
                isOpen={showAddAppointmentModal}
                onClose={() => { setShowAddAppointmentModal(false); setAppointmentToEdit(null); }}
                title="Appointment"
                width="50%"
            >
                <div className="drawer-body">
                    <h2 className="drawer-title">
                        {appointmentToEdit ? 'Edit Appointment' : 'Add Appointment'}
                    </h2>

                    <AddAppointment
                        onClose={() => { setShowAddAppointmentModal(false); setAppointmentToEdit(null); }}
                        appointmentData={appointmentToEdit}
                        isEdit={!!appointmentToEdit}
                        onSubmit={() => {
                            // The AddAppointment component already handles the API call and shows success alert.
                            // We just need to refresh the data here.
                            fetchTasks();
                            setShowAddAppointmentModal(false);
                            setAppointmentToEdit(null);
                        }}
                    />
                </div>
            </Panels>


            {isEditPanelOpen && selectedEntity && (
                <EntityEdit
                    entityData={selectedEntity}
                    onCancel={() => setIsEditPanelOpen(false)}
                    onSave={() => {
                        setIsEditPanelOpen(false);
                        fetchTasks();
                    }}
                />
            )}

            {/* Mark as Completed Outcome Modal (Image 2 & 3 Parity) */}
            <Dialog
                open={isOutcomeModalOpen}
                onClose={() => setIsOutcomeModalOpen(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: { borderRadius: '12px' }
                }}
            >
                <DialogTitle sx={{ borderBottom: '1px solid #f1f5f9', pb: 2 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" fontWeight="600" color="#334155" sx={{ fontSize: '18px' }}>Add Outcome</Typography>
                        <Box
                            onClick={() => setIsOutcomeModalOpen(false)}
                            sx={{ cursor: 'pointer', color: '#64748b', '&:hover': { color: '#334155' }, fontSize: '20px', fontWeight: 'bold' }}
                        >
                            ✕
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ pt: 3 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 1 }}>
                        <Box>
                            <Typography component="label" sx={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#10b981', mb: 1 }}>
                                Outcome
                            </Typography>
                            <Select
                                fullWidth
                                value={selectedOutcome}
                                onChange={(e) => setSelectedOutcome(e.target.value)}
                                displayEmpty
                                sx={{
                                    borderRadius: '8px',
                                    backgroundColor: '#fff',
                                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#10b981' },
                                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#10b981' },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#10b981', borderWidth: '2px' }
                                }}
                            >
                                <MenuItem value="" disabled>Select Outcome</MenuItem>
                                {[
                                    { Id: 931, Text: "Closed" },
                                    { Id: 930, Text: "pending" },
                                    { Id: 929, Text: "Waiting on customer" },
                                    { Id: 928, Text: "under process" },
                                    { Id: 927, Text: "waiting" }
                                ].map(option => (
                                    <MenuItem key={option.Id} value={option.Id}>{option.Text}</MenuItem>
                                ))}
                            </Select>
                        </Box>

                        <Box>
                            <Typography component="label" sx={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#64748b', mb: 1 }}>
                                Remarks
                            </Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                value={outcomeRemarks}
                                onChange={(e) => setOutcomeRemarks(e.target.value)}
                                placeholder="Enter remarks..."
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                        backgroundColor: '#fff',
                                        '& fieldset': { borderColor: '#e2e8f0' }
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 3, pt: 1, borderTop: 'none', gap: 1.5, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        onClick={() => setIsOutcomeModalOpen(false)}
                        sx={{
                            borderRadius: '8px', px: 3, textTransform: 'none', fontWeight: '600',
                            color: '#fff', backgroundColor: '#14b8a6', '&:hover': { backgroundColor: '#0f766e' }
                        }}
                    >
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleMarkAsCompletedSubmit}
                        disabled={isMarkingComplete || !selectedOutcome}
                        sx={{
                            borderRadius: '8px', px: 4, textTransform: 'none', fontWeight: '600',
                            backgroundColor: '#22c55e', '&:hover': { backgroundColor: '#16a34a' },
                            boxShadow: 'none',
                            '&.Mui-disabled': { backgroundColor: '#e2e8f0' }
                        }}
                    >
                        {isMarkingComplete ? 'Saving...' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Add Comment Modal (Image Parity) */}
            <Dialog
                open={isCommentModalOpen}
                onClose={() => setIsCommentModalOpen(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: { borderRadius: '12px' }
                }}
            >
                <DialogTitle sx={{ borderBottom: '1px solid #f1f5f9', pb: 2 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" fontWeight="600" color="#334155" sx={{ fontSize: '18px' }}>Add Comment</Typography>
                        <Box
                            onClick={() => setIsCommentModalOpen(false)}
                            sx={{ cursor: 'pointer', color: '#64748b', '&:hover': { color: '#334155' }, fontSize: '20px', fontWeight: 'bold' }}
                        >
                            ✕
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ pt: 3 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, mt: 1 }}>
                        <Box>
                            <Typography component="label" sx={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#334155', mb: 1 }}>
                                Comment
                            </Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                value={commentText}
                                onChange={(e) => setCommentText(e.target.value)}
                                placeholder="Please comment here"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                        backgroundColor: '#fff',
                                        '& fieldset': { borderColor: '#e2e8f0' }
                                    }
                                }}
                            />
                        </Box>

                        <Box>
                            <Typography component="label" sx={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#334155', mb: 1 }}>
                                Attachment Title
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <input
                                    type="file"
                                    id="comment-file-input"
                                    hidden
                                    onChange={handleFileChange}
                                />
                                <Button
                                    variant="contained"
                                    component="label"
                                    htmlFor="comment-file-input"
                                    sx={{
                                        backgroundColor: '#22c55e',
                                        '&:hover': { backgroundColor: '#16a34a' },
                                        textTransform: 'none',
                                        borderRadius: '6px',
                                        width: 'fit-content',
                                        px: 2,
                                        py: 0.5,
                                        fontSize: '13px',
                                        boxShadow: 'none',
                                        fontWeight: '700'
                                    }}
                                >
                                    Browse...
                                </Button>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={commentFileName}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    placeholder=""
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '8px',
                                            backgroundColor: '#fff',
                                            '& fieldset': { borderColor: '#e2e8f0' }
                                        }
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 3, pt: 1, borderTop: 'none', gap: 1.5, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        onClick={() => setIsCommentModalOpen(false)}
                        sx={{
                            borderRadius: '8px', px: 4, py: 1, textTransform: 'none', fontWeight: '600',
                            color: '#fff', backgroundColor: '#14b8a6', '&:hover': { backgroundColor: '#0f766e' }
                        }}
                    >
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSaveComment}
                        disabled={isSavingComment}
                        sx={{
                            borderRadius: '8px', px: 4, py: 1, textTransform: 'none', fontWeight: '600',
                            backgroundColor: '#22c55e', '&:hover': { backgroundColor: '#16a34a' },
                            boxShadow: 'none',
                            '&.Mui-disabled': { backgroundColor: '#e2e8f0' }
                        }}
                    >
                        {isSavingComment ? 'Saving...' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>

            {detailMode === 'view' ? (
                <AppointmentTaskDetailPanel
                    isOpen={isDetailOpen && !!selectedAppointment}
                    onClose={() => setIsDetailOpen(false)}
                    id={selectedAppointment?.id}
                    type="appointment"
                    userId={localStorage.getItem('userId') || "34594"}
                    onViewLead={(id) => { setViewingLeadId(id); setIsDetailOpen(false); }}
                    detailData={selectedAppointment}
                />
            ) : (
                <Panels
                    isOpen={isDetailOpen}
                    onClose={() => setIsDetailOpen(false)}
                    backTitle="Appointment"
                    title={detailMode === 'edit' ? 'Edit Appointment' : 'Lead Operation'}
                    width="50%"
                >
                    <LeadActionOperation
                        crmOperationPerms={crmOperationPerms}
                        entity={selectedAppointment}
                        mode={detailMode}
                        onBack={() => setIsDetailOpen(false)}
                        onSuccess={() => {
                            setIsDetailOpen(false);
                            fetchTasks();
                        }}
                    />
                </Panels>
            )}

            {/* Custom Download Modal */}
            <Panels
                isOpen={isCustomDownloadOpen}
                onClose={() => setIsCustomDownloadOpen(false)}
                title="Custom Export"
                width="50%"
            >
                <div className="custom-download-body">
                    <div className="setting-selector">
                        <label>Saved Settings</label>
                        <select className="setting-select" value={selectedCustomSetting} onChange={(e) => {
                            const sid = e.target.value;
                            setSelectedCustomSetting(sid);
                            const setting = customSettings.find(s => s.Id.toString() === sid);
                            if (setting) setSelectedExportFields(setting.CsvColumns.split(','));
                            else setSelectedExportFields([]);
                        }}>
                            <option value="">Select Setting</option>
                            {customSettings.map(s => <option key={s.Id} value={s.Id}>{s.SettingName}</option>)}
                        </select>
                    </div>
                    <div className="field-search-box">
                        <input type="text" placeholder="Search fields..." className="field-search-input" value={fieldSearchTerm} onChange={(e) => setFieldSearchTerm(e.target.value)} />
                    </div>
                    <div className="fields-list">
                        {customExportFields.filter(f => f.ExposedName.toLowerCase().includes(fieldSearchTerm.toLowerCase())).map((f, i) => (
                            <label key={i} className="field-item">
                                <input type="checkbox" checked={selectedExportFields.includes(f.ExposedName)} onChange={() => {
                                    setSelectedExportFields(prev => prev.includes(f.ExposedName) ? prev.filter(x => x !== f.ExposedName) : [...prev, f.ExposedName]);
                                }} />
                                <span className="field-name">{f.ExposedName}</span>
                            </label>
                        ))}
                    </div>
                    <div className="save-setting-row">
                        <input type="text" placeholder="Save Setting" className="save-setting-input" value={exportSettingName} onChange={(e) => setExportSettingName(e.target.value)} />
                        <button className="save-btn" onClick={handleSaveExportSetting}>Save Setting</button>
                    </div>
                </div>
                <div className="custom-download-footer">
                    <button className="final-download-btn" onClick={handleCustomDownloadSubmit} disabled={isDownloading}>{isDownloading ? 'Processing...' : 'Download'}</button>
                </div>
            </Panels>
        </Box>
    );
};

export default AppointmentModule;
